import { useEffect, useState } from "react";
import snake from "../assets/images/snake.png";
import fourty from "../assets/images/twenty.png";
import Swal from "sweetalert2";
import MatchScheduleList from "../Pages/Tv/Iplbattle/matchsceduleList";
import useUserInfo from "../Hooks/useUserInfo";

// Compact formatter used across the app (k / M style)
export const formatNumber = (num) => {
  if (num >= 1000000) {
    return Math.floor(num / 1000000) + "M";
  } else if (num >= 100000) {
    return Math.floor(num / 1000) + "k";
  } else if (num >= 10000) {
    const truncatedValue = Math.floor((num / 1000) * 10) / 10;
    return truncatedValue.toFixed(1).replace(/\.0$/, "") + "k";
  } else if (num >= 1000) {
    return num?.toString();
  } else {
    return num?.toString();
  }
};

// Plain number formatter with comma separation (e.g. 1234567 -> "1,234,567")
export const formatNumberWithCommas = (value) => {
  if (value === null || value === undefined) return "0";
  const num = Number(value);
  if (Number.isNaN(num)) return "0";
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const logoMap2 = {
  CHENNAI: "https://d1ccopf5cw1hft.cloudfront.net/s3data/csk1.png",
  RAJASTHAN: "https://d1ccopf5cw1hft.cloudfront.net/s3data/rr1.png",
  KOLKATA: "https://d1ccopf5cw1hft.cloudfront.net/s3data/kkr1.png",
  BENGALURU: "https://d1ccopf5cw1hft.cloudfront.net/s3data/rcb1.png",
  GUJARAT: "https://d1ccopf5cw1hft.cloudfront.net/s3data/gt1.png",
  MUMBAI: "https://d1ccopf5cw1hft.cloudfront.net/s3data/mi1.png",
  HYDERABAD: "https://d1ccopf5cw1hft.cloudfront.net/s3data/srh1.png",
  PUNJAB: "https://d1ccopf5cw1hft.cloudfront.net/s3data/punjab1.png",
  DELHI: "https://d1ccopf5cw1hft.cloudfront.net/s3data/delhi1.png",
  LUCKNOW: "https://d1ccopf5cw1hft.cloudfront.net/s3data/lsg1.png",
};

export const Images = {
  twoXIplMarket: "https://d1ccopf5cw1hft.cloudfront.net/s3data/2x.svg",
  thirdXIplMarket: "https://d1ccopf5cw1hft.cloudfront.net/s3data/3x.svg",
  fourXIplMarket: "https://d1ccopf5cw1hft.cloudfront.net/s3data/4x.svg",
  fiveXIplAMarket: "https://d1ccopf5cw1hft.cloudfront.net/s3data/5x.svg",
  "2x": "https://d1ccopf5cw1hft.cloudfront.net/s3data/2x.svg",
  "3x": "https://d1ccopf5cw1hft.cloudfront.net/s3data/3x.svg",
  "4x": "https://d1ccopf5cw1hft.cloudfront.net/s3data/4x.svg",
  "5x": "https://d1ccopf5cw1hft.cloudfront.net/s3data/5x.svg",
  cancelIcon: "https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png",
  comboChain: "https://d1ccopf5cw1hft.cloudfront.net/s3data/combo.svg",
  squadMultiplier: "https://d1ccopf5cw1hft.cloudfront.net/s3data/multi.svg",
  fanRally: "https://d1ccopf5cw1hft.cloudfront.net/s3data/rally.svg",
  coinLogo: "https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png",
  clutchMode: "https://d1ccopf5cw1hft.cloudfront.net/s3data/clutch.svg",
  moreIcon: "https://d1ccopf5cw1hft.cloudfront.net/s3data/more.svg",
  memeLogo: "https://d1ccopf5cw1hft.cloudfront.net/s3data/meme-logo.svg",
};
export const EarlyMintWatchPoint = 1;
export const ipl_BoosterDuration = {
  "2x": 60,
  "3x": 120,
  "4x": 150,
  "5x": 180,
  comboChain: 30,
  squadMultiplier: 1800,
  fanRally: 1800,
};

export const convertToIST = (utcDateString) => {
  const date = new Date(utcDateString);

  // Convert to IST (UTC+5:30)
  date.setMinutes(date.getMinutes() + 330); // 5 hours 30 minutes

  // Formatting in "YYYY-MM-DDTHH:mm:ss" format
  const formattedDate = date?.toISOString()?.replace("Z", "")?.split(".")[0];

  return formattedDate;
};
export const CountdownTimer = ({ enddate }) => {
  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
  const goToThePage = (component, name) => {
    updateUserInfo((prev) => {
      return {
        ...prev,
        ...{
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails?.currentComponent,
          lastComponentText: userDetails?.currentComponentText,
          centerCount: userDetails?.centerCount + 1,
        },
      };
    });
  };
  const [timeLeft, setTimeLeft] = useState("");
  // React Router for navigation

  useEffect(() => {
    const updateTimer = () => {
      const now = new Date();
      const end = new Date(enddate);
      let diff = Math.max(0, end - now);

      if (diff === 0) {
        // Show Swal popup when countdown finishes
        Swal.fire({
          title: "Time's Up!",
          text: "The battle has ended. Redirecting...",
          icon: "warning",
          timer: 5000, // Auto close after 3 seconds
          showConfirmButton: false,
        }).then(() => {
          goToThePage(MatchScheduleList, "MatchScheduleList"); // Redirect to another page
          // or use window.location.href = "/results"; if not using React Router
        });
        clearInterval(interval);
        return;
      }

      let hours = Math.floor(diff / (1000 * 60 * 60));
      let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTimeLeft(
        `${String(hours).padStart(2, "0")}H : ${String(minutes).padStart(
          2,
          "0"
        )}M : ${String(seconds).padStart(2, "0")}S`
      );
    };

    updateTimer(); // Initial call
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [enddate]);

  return timeLeft;
};
export const CountdownTimerForList = ({ enddate }) => {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const updateTimer = () => {
      const now = new Date();
      const end = new Date(enddate);
      let diff = Math.max(0, end - now);

      let hours = Math.floor(diff / (1000 * 60 * 60));
      let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTimeLeft(
        ` ${String(hours).padStart(2, "0")}H : ${String(minutes).padStart(
          2,
          "0"
        )}M : ${String(seconds).padStart(2, "0")}S`
      );
    };

    updateTimer(); // Initial call
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [enddate]);

  return timeLeft;
};

export const teamColors = [
  {
    name: "Kolkata",
    background: "#1E083E", //Kolkatta
  },
  {
    name: "Bengaluru",
    background: "#6D0000", //Bengaluru
  },
  {
    name: "Hyderbad",
    background: "#AE6E02", //Hyderbad
  },
  {
    name: "Rajasthan",
    background: "#720A40", //Rajastha
  },
  {
    name: "Chennai",
    background: "#8A7E00", //chennai
  },
  {
    name: "Mumbai",
    background: "#134381", //Mumbai
  },
  {
    name: "Delhi",
    background: "#0057E2", //Delhi
  },
  {
    name: "Lucknow",
    background: "#134381", //Lucknow
  },
  {
    name: "Gujarat",
    background: "#181E31", //Gujarat
  },
  {
    name: "Punjab",
    background: "#7F0F17", //Punjab
  },
];
export const getTeamColorsByLeague = (teamName, leagueType) => {
  const leagueColors = {
    ipl: {
      KOLKATA: { name: "KOLKATA", background: "#1E083E" },
      BENGALURU: { name: "BENGALURU", background: "#6D0000" },
      HYDERABAD: { name: "HYDERABAD", background: "#AE6E02" },
      RAJASTHAN: { name: "RAJASTHAN", background: "#720A40" },
      CHENNAI: { name: "CHENNAI", background: "#8A7E00" },
      MUMBAI: { name: "MUMBAI", background: "#134381" },
      DELHI: { name: "DELHI", background: "#0057E2" },
      LUCKNOW: { name: "LUCKNOW", background: "#134381" },
      GUJARAT: { name: "GUJARAT", background: "#181E31" },
      PUNJAB: { name: "PUNJAB", background: "#7F0F17" },
    },
    tnpl: {
      DINDIGUL: { name: "DINDIGUL", background: "#FFD700" }, // Gold
      COIMBATORE: { name: "COIMBATORE", background: "#4169E1" }, // Royal Blue
      MADURAI: { name: "MADURAI", background: "#134381" }, // Orange Red
      SALEM: { name: "SALEM", background: "#6D0000" }, // Lime Green
      TIRUPPUR: { name: "TIRUPPUR", background: "#720A40" }, // Blue Violet
      NELLAI: { name: "NELLAI", background: "#8A7E00" }, // Deep Pink
      CHEPAUK: { name: "CHEPAUK", background: "#8A7E00" }, // Dark Turquoise
      TRICHY: { name: "TRICHY", background: "#009B81" }, // Dark Orange
    },

    mpl: {
      RATHNAGIRI: { name: "RATHNAGIRI", background: "#181E31" }, // Indigo
      NASHIK: { name: "NASHIK", background: "#8A7E00" }, // Dark Green
      SATARA: { name: "SATARA", background: "#8B4513" }, // Saddle Brown
      RAIGAD: { name: "RAIGAD", background: "#720A40" }, // Peru
      PUNERI: { name: "PUNERI", background: "#134381" }, // Dark Red
      KOLHAPUR: { name: "KOLHAPUR", background: "#6D0000" }, // Dark Slate Blue
    },
  };

  const league = leagueColors[leagueType] || leagueColors?.ipl;

  return league[teamName] || { name: teamName, background: "#333333" }; // Default color if team not found
};
export const gamesList = [
  // {
  //   id: 1,
  //   name: "FUN QUIZ",
  //   type: "quiz",
  //   ref: "quiz",
  //   image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/funquiz.svg",
  // },
  // {
  //   id: 2,
  //   name: "WORD SCRAMBLE",
  //   type: "word",
  //   ref: "scramble",
  //   image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/wordscramble.svg",
  // },
  {
    id: 3,
    name: "Pick a Card",
    type: "card",
    ref: "Pickaword",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/pickcard-1.svg",
  },
  {
    id: 4,
    name: "Tic Tac Toe",
    type: "card",
    ref: "tictactoe",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/tictactoe-1.svg",
  },
  {
    id: 5,
    name: "2048",
    type: "number",
    ref: "twenty",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/twenty-1.png",
  },
  {
    id: 6,
    name: "Snake",
    type: "play",
    ref: "Snake",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/snake-1.png",
  },
  {
    id: 7,
    name: "Meme Matching",
    type: "card",
    ref: "matchmeme",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/memematching-1.png",
  },

  {
    id: 8,
    name: "Breakout Meme",
    type: "word",
    ref: "breakmeme",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/breakout-1.png",
  },
  {
    id: 9,
    name: "Cricket Game",
    type: "word",
    ref: "cricket",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/ufw2025-1.png",
  },
  {
    id: 10,
    name: "Flappy",
    type: "game",
    ref: "Flappy",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/flappy.png",
  },
  {
    id: 11,
    name: "Whack-A-Meme",
    type: "game",
    ref: "WhackAMole",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/whack.png",
  },
  {
    id: 12,
    name: "Slide Puzzle",
    type: "word",
    ref: "puzzle",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/puzzle.png",
  },

  // {
  //   id: 13,
  //   name: "Connectfour",
  //   type: "number",
  //   ref: "Connectfour",
  //   image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/connectfour.png",
  // },
  {
    id: 14,
    name: "Rock Paper Scissors",
    type: "game",
    ref: "rockpaperscissors",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/rps.png",
  },
  {
    id: 15,
    name: "Quento",
    type: "number",
    ref: "quento",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/quanto.png",
  },
  {
    id: 16,
    name: "Dino Runner",
    type: "game",
    ref: "dino",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/dino.png",
  },
  {
    id: 17,
    name: "Meme Crush",
    type: "game",
    ref: "MemeCandy",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/memecrush.png",
  },
  {
    id: 18,
    name: "Hangman",
    type: "game",
    ref: "hangman",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/hangman.png",
  },

  {
    id: "19",
    name: "SIMON SAYS",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/simon.png",
    ref: "Simonsays",
    info: "Test your memory by repeating color patterns",
  },
  {
    id: "20",
    name: "Web3 Quiz",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/webquiz-1.png",
    ref: "Web3Quiz",
    info: "Test your memory by repeating color patterns",
  },
  {
    id: 21,
    name: "Rainbow Connect",
    type: "game",
    ref: "RainbowConnect",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/rainbow.png",
  },
  {
    id: 22,
    name: "minesweeper",
    type: "game",
    ref: "Minesweeper",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/minesweeper.png",
  },
  {
    id: 24,
    name: "spaceinvader",
    type: "game",
    ref: "spaceinvader",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/spaceinvader.png",
  },
  {
    id: 23,
    name: "tetris",
    type: "game",
    ref: "tetris",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/tetris.png",
  },
  {
    id: 25,
    name: "stacker",
    type: "game",
    ref: "stacker",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/stacked.png",
  },
  {
    id: 26,
    name: "Fruit Slicer",
    type: "game",
    ref: "fruitslice",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/fruitcut.png",
  },
  {
    id: 27,
    name: "Two Cars",
    type: "game",
    ref: "CarRace",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/two_cars.png",
  },
  {
    id: 28,
    name: "Tic Tac Toe Multiplayer",
    type: "game",
    ref: "TicTacToeWeb",
    image:
      "https://d1ccopf5cw1hft.cloudfront.net/s3data/TicTacToe-Multiplayer.png",
  },
  {
    id: 29,
    name: "Mario Run",
    type: "game",
    ref: "MarioJump",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/mario.png",
  },
  {
    id: 30,
    name: "TURBO RACE",
    type: "game",
    ref: "Racing",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/turborace.png",
  },

  // {
  //   id: 31,
  //   name: "Beachy Ball",
  //   type: "game",
  //   ref: "BeachyBall",
  //   image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/beachyball.png",
  // },

  // {
  //   id: 32,
  //   name: "Chess",
  //   type: "game",
  //   ref: "Chess",
  //   image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/chess.svg",
  // },
  {
    id: 31,
    name: "Multiplayer Chess",
    type: "game",
    ref: "ChessWeb",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/chess.png",
  },
  {
    id: 32,
    name: "Multiplayer Connect Four",
    type: "game",
    ref: "ConnectFourWeb",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/connectfour.png",
  },
  {
    id: 33,
    name: "Snake Ladder",
    type: "game",
    ref: "SnakeLadder",
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/Snakesandladder.jpg",
  },
  {
    id: 34,
    name: "UNO Card Game",
    type: "game",
    ref: "UnoGame",
    image: "https://upload.wikimedia.org/wikipedia/en/9/97/Uno_video_game_cover.jpg?20220310161013",
  },
]?.sort((a, b) => b?.id - a?.id);

export const TutorialSlides = [
  {
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/tutorial1.svg", // Example image

    headline: "DONOTHING",
    description: "Watch TheMemeTV to get tokens effortlessly.",
  },
  {
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/tutorial2.svg",
    headline: "DO & earn",
    description:
      "Tap, play mini-games, invite friends and follow us to unlock extra tokens.",
  },
  {
    image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/tutorial3.svg",
    headline: "Streak & Stake",
    description: "Maintain streaks and stake tokens to rack up more tokens.",
  },
];
export const FunQuizQues = [
  {
    id: 1,
    question: "Which flower does Sarah prefer to keep in her balcony garden?",
    options: ["Roses", "Lilies", "Orchids", "Geraniums"],
    answer: "Orchids",
  },
  {
    id: 2,
    question:
      "What time does Olivia aim to arrive at the airport before her flight?",
    options: [
      "2 hours before",
      "3 hours before",
      "1 hour before",
      "4 hours before",
    ],
    answer: "2 hours before",
  },
  {
    id: 3,
    question: "What color is Emily's favorite chair in the living room?",
    options: ["Brown", "Gray", "Beige", "Blue"],
    answer: "Blue",
  },
  {
    id: 4,
    question:
      "Which document is crucial for Alex to carry during international travel?",
    options: [
      "Passport",
      "Driver's license",
      "Health insurance card",
      "Credit card",
    ],
    answer: "Passport",
  },
  {
    id: 5,
    question: "What has cities but no houses?",
    options: ["Map", "Globe", "Telephone", "Calendar"],
    answer: "Map",
  },
  {
    id: 6,
    question: "What type of phone charger does Sarah always keep in her bag?",
    options: [
      "Lightning cable",
      "USB-C cable",
      "Micro-USB cable",
      "Wireless charger",
    ],
    answer: "USB-C cable",
  },
  {
    id: 7,
    question: "What type of sofa does Tom have in his living room?",
    options: ["Loveseat", "Sectional sofa", "Recliner sofa", "Sleeper sofa"],
    answer: "Sectional sofa",
  },
  {
    id: 8,
    question:
      "Which brand of laptop charger does Jack use for his work laptop?",
    options: ["Dell", "HP", "Lenovo", "Apple"],
    answer: "Lenovo",
  },
  {
    id: 9,
    question: "Where does Emma keep her favorite flower pot in the garden?",
    options: [
      "Hanging on the railing",
      "On the ground",
      "On a shelf",
      "On a pedestal",
    ],
    answer: "On a shelf",
  },
  {
    id: 10,
    question: "What can travel around the world while staying in a corner?",
    options: ["Letter", "Airplane", "Globe", "Stamp"],
    answer: "Stamp",
  },
  {
    id: 11,
    question:
      "How long does Emily's phone battery typically last on a full charge?",
    options: ["8 hours", "12 hours", "16 hours", "24 hours"],
    answer: "16 hours",
  },
  {
    id: 12,
    question: "Where does Emma prefer to charge her devices at home?",
    options: [
      "Office desk",
      "Bedside table",
      "Kitchen counter",
      "Living room sofa",
    ],
    answer: "Bedside table",
  },
  {
    id: 13,
    question: "How does Alex troubleshoot a laptop charger that isn't working?",
    options: [
      "Check the power outlet",
      "Inspect the cable for damage",
      "Restart the laptop",
      "Use a different charger",
    ],
    answer: "Inspect the cable for damage",
  },
  {
    id: 14,
    question:
      "Which farming technique is Farmer Mia experimenting with to improve crop yield?",
    options: [
      "Hydroponics",
      "Vertical farming",
      "Precision agriculture",
      "Organic farming",
    ],
    answer: "Vertical farming",
  },
  {
    id: 15,
    question: "What goes up but never comes down?",
    options: ["Age", "Temperature", "Airplane", "Sun"],
    answer: "Age",
  },
  {
    id: 16,
    question:
      "Which type of necklace does Laura like to layer with her outfits?",
    options: ["Gold chains", "Choker", "Pendant", "Beaded"],
    answer: "Gold chains",
  },
  {
    id: 17,
    question: "Who is John's neighbor?",
    options: ["Peter", "Sam", "Jenny", "Sara"],
    answer: "Sam",
  },
  {
    id: 18,
    question: "What is Sam's Beagle dog's favorite food?",
    options: ["Chicken", "Beef", "Lamb", "Pork"],
    answer: "Chicken",
  },
  {
    id: 19,
    question:
      "What type of kitchen appliance does Emily use most often for cooking?",
    options: ["Microwave", "Blender", "Toaster", "Slow cooker"],
    answer: "Slow cooker",
  },
  {
    id: 20,
    question:
      "I'm light as a feather, yet the strongest person can't hold me for much longer than a minute. What am I?",
    options: ["Breath", "Thought", "Feather", "Whisper"],
    answer: "Breath",
  },
  {
    id: 21,
    question: "What breed is Peter's dog?",
    options: ["Golden Retriever", "Poodle", "Beagle", "German Shepherd"],
    answer: "German Shepherd",
  },
  {
    id: 22,
    question: "Which TV channel does Tom watch for his favorite songs?",
    options: ["MusicMix", "SongQuest", "Melody Channel", "TuneIn TV"],
    answer: "Melody Channel",
  },
  {
    id: 23,
    question: "What type of fan does Tom use to stay cool during summer?",
    options: ["Ceiling fan", "Tower fan", "Pedestal fan", "Box fan"],
    answer: "Tower fan",
  },
  {
    id: 24,
    question:
      "Where does Jack keep his collection of board games in his living room?",
    options: [
      "On a shelf",
      "In a storage ottoman",
      "Stacked in a corner",
      "In a cabinet",
    ],
    answer: "In a cabinet",
  },
  {
    id: 25,
    question: "What can you catch but not throw?",
    options: ["Airplane", "Ball", "Cold", "Fish"],
    answer: "Cold",
  },
  {
    id: 26,
    question: "How does Laura typically handle laundry?",
    options: [
      "Sorting by color and fabric",
      "Using a pre-wash cycle",
      "Hand washing delicate items",
      "Dry cleaning only",
    ],
    answer: "Sorting by color and fabric",
  },
  {
    id: 27,
    question: "Which plant does Jessica prefer for her outdoor garden?",
    options: ["Tomato plant", "Lavender", "Zinnias", "Ferns"],
    answer: "Lavender",
  },
  {
    id: 28,
    question:
      "What type of plant does Sarah choose for low-light areas in her home?",
    options: ["ZZ plant", "Boston fern", "Aloe vera", "Cactus"],
    answer: "ZZ plant",
  },
  {
    id: 29,
    question: "What pet does Peter have?",
    options: ["Dog", "Parrot", "Cat", "Horse"],
    answer: "Cat",
  },
  {
    id: 30,
    question: "The more you take, the more you leave behind. What am I?",
    options: ["Time", "Breath", "Memories", "Footsteps"],
    answer: "Footsteps",
  },
  {
    id: 31,
    question:
      "What is Laura's go-to plant for adding greenery to her workspace?",
    options: ["Succulent", "Bamboo", "Snake plant", "Philodendron"],
    answer: "Bamboo",
  },
  {
    id: 32,
    question: "Which jewelry style does Chloe most enjoy for casual wear?",
    options: [
      "Bangles",
      "Hoop earrings",
      "Charm bracelet",
      "Layered necklaces",
    ],
    answer: "Hoop earrings",
  },
  {
    id: 33,
    question: "What is Emily's favorite type of houseplant?",
    options: ["Snake plant", "Spider plant", "Peace lily", "Pothos"],
    answer: "Pothos",
  },
  {
    id: 34,
    question: "Where does Tom keep his collection of spices in the kitchen?",
    options: [
      "Spice rack",
      "Pantry shelf",
      "Kitchen drawer",
      "Cabinet door organizer",
    ],
    answer: "Spice rack",
  },
  {
    id: 35,
    question: "I'm tall when I'm young, and I'm short when I'm old. What am I?",
    options: ["Pencil", "Candle", "Tree", "Rope"],
    answer: "Candle",
  },
  {
    id: 36,
    question: "What type of sandal does Emily wear for casual outings?",
    options: ["Flip-flops", "Wedges", "Sandals", "Espadrilles"],
    answer: "Espadrilles",
  },
  {
    id: 37,
    question: "In which butcher's shop does Peter buy lamb?",
    options: [
      "Smith's Butcher Shop",
      "Johnson's Meat Market",
      "Wilson & Sons Butchers",
      "Miller's Fine Meats",
    ],
    answer: "Wilson & Sons Butchers",
  },
  {
    id: 38,
    question: "What brand of TV does Jack have in his living room?",
    options: ["VisionTech", "CrystalClear", "UltraView", "SmartView"],
    answer: "UltraView",
  },
  {
    id: 39,
    question: "Which service does Jessica prefer for her hair care routine?",
    options: ["Coloring", "Keratin treatment", "Blowout", "Scalp treatment"],
    answer: "Keratin treatment",
  },
  {
    id: 40,
    question: "What belongs to you, but others use it more than you do?",
    options: ["Voice", "Phone", "Thoughts", "Name"],
    answer: "Name",
  },
  {
    id: 41,
    question:
      "Which online platform does Jordan use most for fashion shopping?",
    options: ["ASOS", "Amazon", "eBay", "Zara"],
    answer: "ASOS",
  },
  {
    id: 42,
    question:
      "What is Jamie's preferred gift to bring when visiting a friend's home?",
    options: ["Flowers", "A bottle of wine", "Homemade cookies", "A book"],
    answer: "Homemade cookies",
  },
  {
    id: 43,
    question:
      "Which device did Morgan accidentally damage, leading to a repair appointment?",
    options: ["Smart speaker", "Gaming console", "Digital camera", "E-reader"],
    answer: "Digital camera",
  },
  {
    id: 44,
    question: "What is Alex's favorite type of sale?",
    options: [
      "Black Friday",
      "Cyber Monday",
      "End-of-season clearance",
      "Buy-one-get-one-free",
    ],
    answer: "Black Friday",
  },
  {
    id: 45,
    question: "What has a bed but never sleeps?",
    options: ["Pillow", "River", "Garden", "Book"],
    answer: "River",
  },
  {
    id: 46,
    question:
      "What does Jordan often do to prepare their home for a friend's visit?",
    options: [
      "Clean and organize",
      "Decorate with fresh flowers",
      "Cook a special meal",
      "Set up a guest room",
    ],
    answer: "Clean and organize",
  },
  {
    id: 47,
    question: "Where does Jamie usually buy their tech gadgets?",
    options: ["Newegg", "Apple Store", "B&H Photo", "Micro Center"],
    answer: "Micro Center",
  },
  {
    id: 48,
    question:
      "What type of dining option is Taylor's favorite at the shopping mall food court?",
    options: [
      "Fast food",
      "Sit-down restaurant",
      "Asian cuisine",
      "Vegan cafe",
    ],
    answer: "Asian cuisine",
  },
  {
    id: 49,
    question: "What is Jamie's favorite hobby for relaxation?",
    options: ["Gardening", "Painting", "Reading", "Cooking"],
    answer: "Reading",
  },
  {
    id: 50,
    question: "What has a head, a tail, and has no legs?",
    options: ["Snake", "Worm", "Coin", "Pencil"],
    answer: "Coin",
  },
  {
    id: 51,
    question: "When does Tom's flight depart?",
    options: ["10:00 AM", "1:00 PM", "4:00 PM", "7:00 PM"],
    answer: "4:00 PM",
  },
  {
    id: 52,
    question:
      "Which beauty parlour service does Laura book before special events?",
    options: [
      "Makeup application",
      "Eyelash extensions",
      "Spray tan",
      "Hair styling",
    ],
    answer: "Hair styling",
  },
  {
    id: 53,
    question: "What hobby does Taylor enjoy that involves creative writing?",
    options: ["Poetry", "Short stories", "Journaling", "Blogging"],
    answer: "Short stories",
  },
  {
    id: 54,
    question: "Which dance style does Jamie most enjoy practicing?",
    options: ["Ballet", "Hip-hop", "Salsa", "Contemporary"],
    answer: "Contemporary",
  },
  {
    id: 55,
    question: "What has teeth but can't bite?",
    options: ["Comb", "Key", "Clock", "Zipper"],
    answer: "Comb",
  },
  {
    id: 56,
    question:
      "Which study method does Taylor find most effective before an exam?",
    options: [
      "Flashcards",
      "Study groups",
      "Practice tests",
      "Reading textbooks",
    ],
    answer: "Practice tests",
  },
  {
    id: 57,
    question:
      "Which activity does Jordan find most effective for calming down after a stressful day?",
    options: [
      "Taking a bath",
      "Cooking a meal",
      "Reading a book",
      "Doing yoga",
    ],
    answer: "Doing yoga",
  },
  {
    id: 58,
    question: "What hobby does Alex engage in to explore new cultures?",
    options: [
      "Cooking international dishes",
      "Learning new languages",
      "Traveling",
      "Attending cultural festivals",
    ],
    answer: "Traveling",
  },
  {
    id: 59,
    question: "What technique does Jamie use to manage anger effectively?",
    options: [
      "Deep breathing",
      "Journaling",
      "Physical exercise",
      "Talking to a friend",
    ],
    answer: "Deep breathing",
  },
  {
    id: 60,
    question: "What has a neck but no head?",
    options: ["Giraffe", "Shirt", "Lamp", "Bottle"],
    answer: "Bottle",
  },
  {
    id: 61,
    question: "Which hobby does Taylor enjoy most on weekends?",
    options: [
      "Hiking",
      "Playing video games",
      "Playing a musical instrument",
      "Knitting",
    ],
    answer: "Hiking",
  },
  {
    id: 62,
    question: "What hobby does Morgan practice to stay active?",
    options: ["Yoga", "Photography", "Birdwatching", "Writing"],
    answer: "Yoga",
  },
  {
    id: 63,
    question:
      "What is Alex's primary reason for buying organic vegetables at the market?",
    options: [
      "Health benefits",
      "Better taste",
      "Environmental concerns",
      "Support local farmers",
    ],
    answer: "Health benefits",
  },
  {
    id: 64,
    question:
      "Which nail polish technique does Chloe use to create a unique look?",
    options: ["Ombré", "Nail art decals", "Water marble", "Foil accents"],
    answer: "Water marble",
  },
  {
    id: 65,
    question: "What gets wetter as it dries?",
    options: ["Sponge", "Towel", "Soap", "Hair"],
    answer: "Towel",
  },
  {
    id: 66,
    question:
      "Which ice cream flavor is Jordan's favorite when having a scoop on a waffle cone?",
    options: ["Rocky road", "Pistachio", "Cookies and cream", "Neapolitan"],
    answer: "Cookies and cream",
  },
  {
    id: 67,
    question:
      "Which side dish does Jordan consider essential for a Thanksgiving feast?",
    options: [
      "Mashed potatoes",
      "Green bean casserole",
      "Stuffing",
      "Cranberry sauce",
    ],
    answer: "Stuffing",
  },
  {
    id: 68,
    question:
      "What type of dance class does Jordan attend to improve rhythm and coordination?",
    options: [
      "Breakdancing",
      "Latin dance",
      "Swing dance",
      "Contemporary dance",
    ],
    answer: "Swing dance",
  },
  {
    id: 69,
    question: "Which ice cream flavor is Alex known for making at home?",
    options: [
      "Salted caramel",
      "Almond joy",
      "Pumpkin spice",
      "Brownie batter",
    ],
    answer: "Salted caramel",
  },
  {
    id: 70,
    question:
      "I have keys but no locks. I have space but no rooms. You can enter, but you can't go outside. What am I?",
    options: ["A smartphone", "A keyboard", "A monitor", "A tablet"],
    answer: "A keyboard",
  },
  {
    id: 71,
    question:
      "What is Laura's go-to nail polish brand for long-lasting results?",
    options: ["OPI", "Essie", "Sally Hansen", "Revlon"],
    answer: "Sally Hansen",
  },
  {
    id: 72,
    question:
      "What flavor does Morgan most often choose when ordering a sundae?",
    options: ["Butter pecan", "Cherry vanilla", "Tiramisu", "Mint chip"],
    answer: "Mint chip",
  },
  {
    id: 73,
    question: "What is Alex's preferred beverage for a celebratory feast?",
    options: ["Sparkling cider", "Red wine", "Lemonade", "Champagne"],
    answer: "Champagne",
  },
  {
    id: 74,
    question:
      "What does Michael always carry to ensure his devices stay charged during travel?",
    options: ["Power bank", "Extra batteries", "Car charger", "Solar charger"],
    answer: "Power bank",
  },
  {
    id: 75,
    question:
      "What comes once in a minute, twice in a moment, but never in a thousand years?",
    options: [
      "The number '1'",
      "The letter 'M'",
      "The word 'now'",
      "The opportunity",
    ],
    answer: "The letter 'M'",
  },
  {
    id: 76,
    question: "How does Jack conserve his laptop battery during long meetings?",
    options: [
      "Lowering screen brightness",
      "Closing unnecessary applications",
      "Using battery saver mode",
      "Plugging into a power source",
    ],
    answer: "Lowering screen brightness",
  },
  {
    id: 77,
    question: "What payment method does Emily prefer for online shopping?",
    options: ["Credit card", "PayPal", "Debit card", "Digital wallet"],
    answer: "PayPal",
  },
  {
    id: 78,
    question: "Which device does Alex find has the quickest charging time?",
    options: ["Tablet", "Smartwatch", "Headphones", "Laptop"],
    answer: "Smartwatch",
  },
  {
    id: 79,
    question:
      "What does Michael always carry to ensure his devices stay charged during travel?",
    options: ["Power bank", "Extra batteries", "Car charger", "Solar charger"],
    answer: "Power bank",
  },
  {
    id: 80,
    question: "What has a face but can't smile?",
    options: ["Mask", "Painting", "Clock", "Mirror"],
    answer: "Clock",
  },
  {
    id: 81,
    question: "How old is Kabir?",
    options: ["2 years old", "10 years old", "12 years old", "18 years old"],
    answer: "12 years old",
  },
  {
    id: 82,
    question:
      "Which healthy food does Emily include in her daily diet for its nutritional benefits?",
    options: ["Quinoa", "Kale", "Chia seeds", "Avocado"],
    answer: "Avocado",
  },
  {
    id: 83,
    question:
      "What is Sarah's favorite fragrance in her collection of perfumes?",
    options: ["Floral bouquet", "Citrus zest", "Woody musk", "Vanilla bean"],
    answer: "Vanilla bean",
  },
  {
    id: 84,
    question:
      "Which brand of toothpaste does Emily trust for her daily dental care routine?",
    options: ["BrightSmile", "FreshDent", "SparkleClean", "MintyFresh"],
    answer: "MintyFresh",
  },
  {
    id: 85,
    question: "What has hands but can't clap?",
    options: ["Statue", "Gloves", "Robot", "Clock"],
    answer: "Clock",
  },
  {
    id: 86,
    question:
      "What does Mia do to maximize the efficiency of her laptop charger?",
    options: [
      "Unplug when fully charged",
      "Use a surge protector",
      "Keep it in a cool place",
      "Use eco-friendly chargers",
    ],
    answer: "Keep it in a cool place",
  },
  {
    id: 87,
    question:
      "How does Farmer Emma implement sustainable practices on her farm?",
    options: [
      "Crop rotation",
      "Water conservation",
      "Renewable energy use",
      "Soil health management",
    ],
    answer: "Soil health management",
  },
  {
    id: 88,
    question:
      "How long does Olivia typically leave her phone on the charger each night?",
    options: ["1-2 hours", "Until fully charged", "4-6 hours", "Overnight"],
    answer: "Overnight",
  },
  {
    id: 89,
    question: "Where did Tom go for his last medical check-up?",
    options: [
      "City Health Clinic",
      "Wellness Center",
      "MedCare Hospital",
      "HealthFirst Clinic",
    ],
    answer: "Wellness Center",
  },
  {
    id: 90,
    question: "I have branches, but no leaves or fruit. What am I?",
    options: ["A tree", "Plant", "A bank", "Class"],
    answer: "A bank",
  },
  {
    id: 91,
    question:
      "Who is Emma's favorite nutritionist for advice on healthy eating?",
    options: [
      "Nutrition Balance",
      "Health First Nutrition",
      "Vitality Nutrition",
      "Balanced Diet Consulting",
    ],
    answer: "Vitality Nutrition",
  },
  {
    id: 92,
    question: "Which feature does James prioritize when buying a power bank?",
    options: [
      "Fast charging capability",
      "High capacity",
      "Lightweight design",
      "Compatibility with multiple devices",
    ],
    answer: "Fast charging capability",
  },
  {
    id: 93,
    question:
      "What is Tom's go-to remedy for relieving muscle pain after intense workouts?",
    options: [
      "Heating pad",
      "Ice pack",
      "Pain relief cream",
      "Massage therapy",
    ],
    answer: "Massage therapy",
  },
  {
    id: 94,
    question:
      "What brand of tissue paper does Emily always keep stocked at home?",
    options: ["SoftTouch", "GentleCare", "PurePly", "SilkSoft"],
    answer: "GentleCare",
  },
  {
    id: 95,
    question: "I write without ink, but I'm not invisible. What am I?",
    options: ["A pen", "A pencil", "A feather", "A typewriter"],
    answer: "A pencil",
  },
  {
    id: 96,
    question: "What brand of fridge does Sarah have in her kitchen?",
    options: ["ChillMaster", "FrostTech", "CoolBreeze", "FreezeZone"],
    answer: "CoolBreeze",
  },
  {
    id: 97,
    question:
      "What feature does Sarah look for when choosing a new sofa for her living room?",
    options: [
      "Comfort level",
      "Size and shape",
      "Fabric or material",
      "Color scheme",
    ],
    answer: "Comfort level",
  },
  {
    id: 98,
    question: "What does Sarah enjoy doing the most on her terrace?",
    options: ["Gardening", "Reading", "Sunbathing", "Hosting gatherings"],
    answer: "Sunbathing",
  },
  {
    id: 99,
    question:
      "Which phone model boasts the longest battery life, according to Emily's research?",
    options: ["Samsung Galaxy", "iPhone", "Google Pixel", "Huawei Mate"],
    answer: "Huawei Mate",
  },
  {
    id: 100,
    question: "I can be painted but I'm not a canvas. What am I?",
    options: ["Paper", "Hair", "Fingernails", "Clothes"],
    answer: "Hair",
  },
  {
    id: 101,
    question: "How far is the nearest temple from Sarah's home?",
    options: ["1 mile", "3 miles", "5 miles", "8 miles"],
    answer: "3 miles",
  },
  {
    id: 102,
    question:
      "Who does Sarah typically list as a professional reference for her job applications?",
    options: [
      "Former manager",
      "Colleague from a previous job",
      "Industry mentor",
      "University professor",
    ],
    answer: "Former manager",
  },
  {
    id: 103,
    question: "Who is Alex's best friend in school?",
    options: ["Emily", "Jack", "Mia", "Olivia"],
    answer: "Olivia",
  },
  {
    id: 104,
    question:
      "Who conducts the final interview for positions at Tom's company?",
    options: ["HR manager", "Department head", "CEO", "MD"],
    answer: "Department head",
  },
  {
    id: 105,
    question: "I can be cracked, made, told, and played. What am I?",
    options: ["Joke", "Riddle", "Game", "Song"],
    answer: "Joke",
  },
  {
    id: 106,
    question:
      "What resource does Student Tom often use in the college library for research?",
    options: ["Books", "Online databases", "Journals", "Audiovisual materials"],
    answer: "Online databases",
  },
  {
    id: 107,
    question: "How does Michael prepare for job interviews?",
    options: [
      "Practicing mock interviews",
      "Researching the company",
      "Revising resume",
      "Revising portfolio",
    ],
    answer: "Researching the company",
  },
  {
    id: 108,
    question: "How many pets does Alex have?",
    options: ["1", "2", "3", "4"],
    answer: "2",
  },
  {
    id: 109,
    question: "What is Sarah's favorite piece of jewelry to wear daily?",
    options: [
      "Pendant necklace",
      "Stud earrings",
      "Tennis bracelet",
      "Statement ring",
    ],
    answer: "Stud earrings",
  },
  {
    id: 110,
    question:
      "I speak without a mouth and hear without ears. I have no body, but I come alive with the wind. What am I?",
    options: ["Dream", "Echo", "Whisper", "Thought"],
    answer: "Echo",
  },
  {
    id: 111,
    question:
      "Where does Emily usually place fresh flowers on her dining table?",
    options: ["Centerpiece", "Corners", "Along the edges", "Near the window"],
    answer: "Centerpiece",
  },
  {
    id: 112,
    question: "Which cycle brand does Jack own for his daily commute?",
    options: ["SpeedRider", "UrbanCycle", "EcoBike", "TrailBlazer"],
    answer: "UrbanCycle",
  },
  {
    id: 113,
    question:
      "What type of food delivery service does Sarah prefer to use for ordering meals?",
    options: [
      "FastFood Express",
      "Gourmet Delights",
      "HealthyBite",
      "QuickEats",
    ],
    answer: "HealthyBite",
  },
  {
    id: 114,
    question: "Which washing machine feature does Jack find most useful?",
    options: ["Quick wash", "Eco mode", "Steam wash", "Silent wash"],
    answer: "Eco mode",
  },
  {
    id: 115,
    question:
      "The person who makes it, sells it. The person who buys it never uses it. What is it?",
    options: ["Mirror", "Shoes", "Coffin", "Chair"],
    answer: "Coffin",
  },
  {
    id: 116,
    question: "Where does Michael usually keep the newspaper after reading it?",
    options: [
      "On the coffee table",
      "In the newspaper rack",
      "On the dining table",
      "On the sofa",
    ],
    answer: "In the newspaper rack",
  },
  {
    id: 117,
    question: "What color dining table does Michael have in his kitchen?",
    options: ["Oak", "Mahogany", "White", "Black"],
    answer: "White",
  },
  {
    id: 118,
    question: "Where is Smith's Butcher Shop located?",
    options: ["Maple Avenue", "Oak Street", "Elm Road", "Unicorn Way"],
    answer: "Oak Street",
  },
  {
    id: 119,
    question: "How many butcher shops are there on Oak Street?",
    options: ["Four", "Five", "Ten", "Two"],
    answer: "Two",
  },
  {
    id: 120,
    question: "I am full of holes but still hold water. What am I?",
    options: ["Bucket", "Net", "Raincoat", "Sponge"],
    answer: "Sponge",
  },
  {
    id: 121,
    question: "Who is the owner of the fifth butcher shop on Oak Street?",
    options: ["Noah", "William", "Olivia", "Amir"],
    answer: "Amir",
  },
  {
    id: 122,
    question: "What is Amir's wife's name?",
    options: ["Olivia", "Riya", "Seena", "Anne"],
    answer: "Riya",
  },
  {
    id: 123,
    question: "How many kids does Seena have?",
    options: ["Two", "Three", "One", "Four"],
    answer: "Two",
  },
  {
    id: 124,
    question:
      "Which music festival is known for showcasing a variety of genres?",
    options: [
      "Harmony Fest",
      "Melody Mania",
      "Rhythm Riot",
      "Symphony Spectacle",
    ],
    answer: "Rhythm Riot",
  },
  {
    id: 125,
    question: "I'm black and white and read all over. What am I?",
    options: ["Newspaper", "Zebra", "Book", "Penguin"],
    answer: "Newspaper",
  },
  {
    id: 126,
    question: "Which ice cream flavor does Taylor choose for a summer party?",
    options: [
      "Pineapple",
      "Blueberry cheesecake",
      "Raspberry ripple",
      "Espresso",
    ],
    answer: "Raspberry ripple",
  },
  {
    id: 127,
    question:
      "Which type of store does Jamie often visit for home decor items?",
    options: ["HomeGoods", "IKEA", "Bed Bath & Beyond", "Pottery Barn"],
    answer: "IKEA",
  },
  {
    id: 128,
    question: "What color is Tom's iron box for pressing clothes?",
    options: ["Silver", "Blue", "Red", "White"],
    answer: "Blue",
  },
  {
    id: 129,
    question: "Where does Morgan usually buy groceries?",
    options: ["Whole Foods", "Trader Joe's", "Safeway", "Kroger"],
    answer: "Trader Joe's",
  },
  {
    id: 130,
    question:
      "I am not alive, but I can grow. I don't have lungs, but I need air. What am I?",
    options: ["Cloud", "Balloon", "Fire", "Plant"],
    answer: "Ballon",
  },
  {
    id: 131,
    question:
      "What type of pillow does Jack use for a comfortable night's sleep?",
    options: ["Memory foam", "Feather", "Polyester", "Latex"],
    answer: "Memory foam",
  },
  {
    id: 132,
    question:
      "What type of clothing does Taylor most frequently shop for online?",
    options: ["Casual wear", "Formal wear", "Sportswear", "Accessories"],
    answer: "Casual wear",
  },
  {
    id: 133,
    question:
      "Which brand of bottled water does Michael always keep on his desk?",
    options: ["AquaPure", "SpringSplash", "CrystalClear", "PureH2O"],
    answer: "CrystalClear",
  },
  {
    id: 134,
    question: "Which store does Jamie prefer for buying electronics?",
    options: ["Best Buy", "Walmart", "Target", "Costco"],
    answer: "Best Buy",
  },
  {
    id: 135,
    question: "I am white and cold, but I'm not snow. What am I?",
    options: ["Cloud", "Salt", "Ice", "Milk"],
    answer: "Ice",
  },
  {
    id: 136,
    question: "What is Taylor's favorite type of cuisine?",
    options: ["Italian", "Mexican", "Japanese", "Indian"],
    answer: "Japanese",
  },
  {
    id: 137,
    question:
      "What is Michael's favorite way to stay connected with friends and family?",
    options: ["Video calls", "Texting", "Social media", "Meeting in person"],
    answer: "Video calls",
  },
  {
    id: 138,
    question: "How does Anna prefer to spend her free time on a rainy day?",
    options: ["Reading indoors", "Watching movies", "Cooking", "Doing puzzles"],
    answer: "Reading indoors",
  },
  {
    id: 139,
    question: "What is Emily's favorite dessert after dinner?",
    options: ["Chocolate cake", "Ice cream", "Apple pie", "Cheesecake"],
    answer: "Ice cream",
  },
  {
    id: 140,
    question: "What has to be broken before you can use it?",
    options: ["Sugar", "Fruits", "Potato", "An egg"],
    answer: "An egg",
  },
  {
    id: 141,
    question: "What is Morgan's preferred mode of transportation?",
    options: ["Bicycle", "Car", "Train", "Airplane"],
    answer: "Car",
  },
  {
    id: 142,
    question: "What is Amy's favorite hobby?",
    options: ["Painting", "Playing guitar", "Cooking", "Gardening"],
    answer: "Gardening",
  },
  {
    id: 143,
    question: "Where does Emily hang her favorite dress in the wardrobe?",
    options: [
      "Left section",
      "Middle section",
      "Front section",
      "Right section",
    ],
    answer: "Middle section",
  },
  {
    id: 144,
    question: "How many books has Jordan read this year?",
    options: ["5", "10", "15", "20"],
    answer: "15",
  },
  {
    id: 145,
    question: "I shave every day, but my beard stays the same. What am I?",
    options: ["Barber", "Mirror", "Razor", "Photograph"],
    answer: "Razor",
  },
  {
    id: 146,
    question: "How does Alex prefer to travel to work?",
    options: ["Car", "Bicycle", "Bus", "Walk"],
    answer: "Car",
  },
  {
    id: 147,
    question: "Where does Anna like to go for her morning jog?",
    options: ["Park", "Beach", "Gym", "Neighborhood"],
    answer: "Park",
  },
  {
    id: 148,
    question: "Which dietary restriction does Morgan follow?",
    options: ["Vegan", "Low-carb", "Paleo", "Dairy-free"],
    answer: "Vegan",
  },
  {
    id: 149,
    question: "Which room does David spend most of his time in at home?",
    options: ["Living room", "Bedroom", "Kitchen", "Study room"],
    answer: "Living room",
  },
  {
    id: 150,
    question: "What is black when it's clean and white when it's dirty?",
    options: ["Panda", "Chalkboard", "Newspaper", "Penguin"],
    answer: "Chalkboard",
  },
  {
    id: 151,
    question: "How many countries has Jamie traveled to?",
    options: [3, 5, 7, 10],
    answer: 7,
  },
  {
    id: 152,
    question: "Which body part did Alex have surgery on last year?",
    options: ["Shoulder", "Knee", "Hip", "Wrist"],
    answer: "Knee",
  },
  {
    id: 153,
    question: "What step does Sarah prioritize when applying for a new job?",
    options: [
      "Updating resume",
      "Networking",
      "Researching companies",
      "Writing cover letters",
    ],
    answer: "Networking",
  },
  {
    id: 154,
    question:
      "What type of surgery did Jordan undergo to improve their vision?",
    options: ["LASIK", "Cataract", "Glaucoma", "Retinal detachment"],
    answer: "LASIK",
  },
  {
    id: 155,
    question: "Where does today come before yesterday?",
    options: ["Time", "Calendar", "Dictionary", "Machine"],
    answer: "Dictionary",
  },
  {
    id: 156,
    question:
      "How often does Tom replace his phone battery to maintain optimal performance?",
    options: [
      "Every year",
      "Every two years",
      "Every three years",
      "Only when necessary",
    ],
    answer: "Only when necessary",
  },
  {
    id: 157,
    question: "When should Tom consider replacing his laptop battery?",
    options: [
      "When it no longer holds a charge",
      "Every 2 years regardless of usage",
      "Only if it overheats",
      "After dropping below 50% capacity",
    ],
    answer: "When it no longer holds a charge",
  },
  {
    id: 158,
    question: "What crop does Farmer John prioritize planting this season?",
    options: ["Wheat", "Corn", "Soybeans", "Potatoes"],
    answer: "Corn",
  },
  {
    id: 159,
    question:
      "What accessory does Michael use to keep his phone charged while hiking?",
    options: [
      "Solar-powered charger",
      "Hand-cranked charger",
      "Wireless charging pad",
      "Battery case",
    ],
    answer: "Solar-powered charger",
  },
  {
    id: 160,
    question: "What kind of band never plays music?",
    options: ["Rubber band", "Rubber stamp", "Elastic", "Hairpin"],
    answer: "Rubber band",
  },
  {
    id: 161,
    question: "Which animal does Farmer Sarah raise on her farm?",
    options: ["Cows", "Chickens", "Sheep", "Goats"],
    answer: "Chickens",
  },
  {
    id: 162,
    question:
      "Which planet does Astronaut Emily dream of exploring in future space missions?",
    options: ["Mars", "Jupiter", "Saturn", "Venus"],
    answer: "Mars",
  },
  {
    id: 163,
    question:
      "What animal does Wildlife Photographer Michael capture in his recent safari expedition?",
    options: ["Lions", "Giraffes", "Zebras", "Leopards"],
    answer: "Leopards",
  },
  {
    id: 164,
    question: "What does James do to manage his laptop charger cable neatly?",
    options: [
      "Use a cable organizer",
      "Wrap it around the adapter",
      "Secure with a Velcro tie",
      "Leave it loose on the desk",
    ],
    answer: "Use a cable organizer",
  },
  {
    id: 165,
    question: "What has words, but never speaks?",
    options: ["Note", "Book", "Watch", "Pen"],
    answer: "Book",
  },
  {
    id: 166,
    question: "Which platform does Mia use to search for job vacancies?",
    options: ["LinkedIn", "Indeed", "Company websites", "Glassdoor"],
    answer: "LinkedIn",
  },
  {
    id: 167,
    question: "Where does Jack go for his weekly yoga classes?",
    options: [
      "Zen Yoga Studio",
      "Serenity Yoga Center",
      "Harmony Yoga Academy",
      "Tranquil Yoga Haven",
    ],
    answer: "Serenity Yoga Center",
  },
  {
    id: 168,
    question:
      "For which condition did Taylor receive surgery on their lower back?",
    options: [
      "Herniated disc",
      "Spinal fusion",
      "Scoliosis correction",
      "Laminectomy",
    ],
    answer: "Herniated disc",
  },
  {
    id: 169,
    question:
      "Which department is currently seeking new employees at Jack's company?",
    options: ["Marketing", "IT", "Human Resources", "Finance"],
    answer: "IT",
  },
  {
    id: 170,
    question: "What has a thumb and four fingers, but is not a hand?",
    options: ["Comb", "Computer", "A glove", "Legs"],
    answer: "A glove",
  },
  {
    id: 171,
    question: "At what time does Priya usually prefer to visit the temple?",
    options: ["Early morning", "Noon", "Evening", "Night"],
    answer: "Early morning",
  },
  {
    id: 172,
    question:
      "Which service does Peter participate in regularly at his church?",
    options: ["Choir", "Youth group", "Bible study", "Volunteer outreach"],
    answer: "Volunteer outreach",
  },
  {
    id: 173,
    question: "Which sport does Jack enjoy playing with his friends?",
    options: ["Basketball", "Tennis", "Swimming", "Cycling"],
    answer: "Basketball",
  },
  {
    id: 174,
    question:
      "Which document does Olivia need to submit for identity verification during her job application?",
    options: [
      "Passport",
      "Driver's license",
      "Birth certificate",
      "Social security card",
    ],
    answer: "Driver's license",
  },
  {
    id: 175,
    question:
      "I am an odd number. Take away a letter and I become even. What number am I?",
    options: ["Three", "Ten", "Four", "Seven"],
    answer: "Seven",
  },
  {
    id: 176,
    question: "What is Morgan's favorite shopping event of the year?",
    options: [
      "Spring sales",
      "Summer clearance",
      "Holiday sales",
      "Back-to-school promotions",
    ],
    answer: "Holiday sales",
  },
  {
    id: 177,
    question:
      "Which type of store does Morgan frequent for buying specialty teas and coffees?",
    options: ["Starbucks", "Teavana", "Dunkin' Donuts", "Whole Foods"],
    answer: "Teavana",
  },
  {
    id: 178,
    question:
      "Where does Jordan typically look for discounts on luxury brands?",
    options: [
      "Outlet malls",
      "Luxury department stores",
      "Online flash sales",
      "Discount warehouses",
    ],
    answer: "Online flash sales",
  },
  {
    id: 179,
    question: "What scent of air freshener does Michael keep in his washroom?",
    options: ["Fresh linen", "Lavender", "Citrus", "Ocean breeze"],
    answer: "Citrus",
  },
  {
    id: 180,
    question:
      "If there are three apples and you take away two, how many apples do you have?",
    options: ["Two", "One", "Three", "Zero"],
    answer: "Two",
  },
  {
    id: 181,
    question: "What is Lisa's favorite genre of movies to watch?",
    options: ["Comedy", "Action", "Drama", "Horror"],
    answer: "Drama",
  },
  {
    id: 182,
    question: "What is Mark's favorite season of the year?",
    options: ["Spring", "Summer", "Autumn", "Winter"],
    answer: "Autumn",
  },
  {
    id: 183,
    question: "How does Emily like her coffee in the morning?",
    options: ["Black", "With milk", "With sugar", "Iced"],
    answer: "Iced",
  },
  {
    id: 184,
    question: "Where does Jack keep his mirror for grooming in the bedroom?",
    options: [
      "Hanging on the wall",
      "On the dresser",
      "Leaning against the wall",
      "Inside the wardrobe door",
    ],
    answer: "On the dresser",
  },
  {
    Id: 185,
    question: "What begins with an 'e' and only contains one letter?",
    options: ["Letter", "Stamp", "Elephant", "Eye"],
    answer: "Eye",
  },
  {
    Id: 186,
    question: "What is Student Michael's favorite dish in the college canteen?",
    options: ["Pizza", "Sandwiches", "Pasta", "Burgers"],
    answer: "Burgers",
  },
  {
    Id: 187,
    question:
      "Where does Alex typically shop for health and wellness products?",
    options: ["GNC", "CVS", "Walgreens", "Vitamin Shoppe"],
    answer: "Vitamin Shoppe",
  },
  {
    Id: 188,
    question:
      "Which teaching method does Professor Emily use to engage her students?",
    options: [
      "Lectures",
      "Group discussions",
      "Case studies",
      "Hands-on projects",
    ],
    answer: "Lectures",
  },
  {
    Id: 189,
    question: "Which type of dress does Sarah prefer for formal occasions?",
    options: ["Little black dress", "Cocktail dress", "Maxi dress", "Pantsuit"],
    answer: "Pantsuit",
  },
  {
    Id: 190,
    question:
      "You see me once in June, twice in November and not at all in May. What am I?",
    options: ["Enemy", "Friend", "The letter 'e'", "The letter 'n'"],
    answer: "Friend",
  },
  {
    Id: 191,
    question:
      "What topic does Sarah choose for her science project this semester?",
    options: ["Volcanoes", "Solar system", "Rainforests", "Dinosaurs"],
    answer: "Solar system",
  },
  {
    Id: 192,
    question:
      "Which book series does Emma borrow most frequently from the school library?",
    options: [
      "Harry Potter",
      "Diary of a Wimpy Kid",
      "Magic Tree House",
      "The Chronicles of Narnia",
    ],
    answer: "Diary of a Wimpy Kid",
  },
  {
    Id: 193,
    question: "What upcoming event is Liam excited about attending at school?",
    options: [
      "Field trip to the zoo",
      "Science fair",
      "Talent show",
      "Sports day",
    ],
    answer: "Science fair",
  },
  {
    Id: 194,
    question: "How does Daniel prefer to unwind after a stressful day?",
    options: [
      "Watching movies",
      "Cooking a nice dinner",
      "Going for a long walk",
      "Listening to music",
    ],
    answer: "Listening to music",
  },
  {
    Id: 195,
    question: "What is 3/7 chicken, 2/3 cat and 2/4 goat?",
    options: ["Goat", "China", "Chicken", "Chicago"],
    answer: "Chicago",
  },
  {
    Id: 196,
    question:
      "At what time does the college bus usually arrive at the campus in the morning?",
    options: ["8:00 AM", "8:30 AM", "9:00 AM", "9:30 AM"],
    answer: "8:30 AM",
  },
  {
    Id: 197,
    question: "Which outdoor activity does David enjoy the most on weekends?",
    options: ["Hiking", "Cycling", "Fishing", "Picnicking"],
    answer: "Picnicking",
  },
  {
    Id: 198,
    question: "What is Michael's favorite school lunch meal?",
    options: ["Pizza", "Chicken nuggets", "Pasta", "Sandwiches"],
    answer: "Pasta",
  },
  {
    Id: 199,
    question:
      "Which category of products does Jordan most often shop for at thrift stores?",
    options: ["Vintage clothing", "Furniture", "Books", "Kitchenware"],
    answer: "Vintage clothing",
  },
  {
    Id: 200,
    question: "What is the end of everything?",
    options: ["End", "Nothing", "The letter 'g'", "The letter 'n'"],
    answer: "The letter 'g'",
  },
  {
    Id: 201,
    question: "In which school does Kabir study?",
    options: [
      "Evergreen Academy",
      "Starlight Elementary",
      "Willowbrook School",
      "Pinecrest High School",
    ],
    answer: "Evergreen Academy",
  },
  {
    Id: 202,
    question: "What is Taylor's go-to store for buying sports equipment?",
    options: [
      "Dick's Sporting Goods",
      "REI",
      "Academy Sports",
      "Sports Authority",
    ],
    answer: "Dick's Sporting Goods",
  },
  {
    Id: 203,
    question:
      "Who is Sarah's preferred dentist for her regular check-ups and cleanings?",
    options: ["Dr. White", "Dr. Bright", "Dr. Smiles", "Dr. Healthy"],
    answer: "Dr. Smiles",
  },
  {
    Id: 204,
    question:
      "Which store does Jamie often visit at the shopping mall for shoes?",
    options: ["Foot Locker", "DSW", "Payless", "Aldo"],
    answer: "Payless",
  },
  {
    id: 205,
    question:
      "I am so simple that I can only point, yet I guide people all over the world.",
    options: ["Compass", "Weather vane", "Signpost", "Traffic light"],
    answer: "Compass",
  },
  {
    id: 206,
    question: "Which gadget did Jamie need repaired after dropping it?",
    options: ["Smartphone", "Tablet", "Laptop", "Smartwatch"],
    answer: "Smartphone",
  },
  {
    id: 207,
    question: "What is the name of Seena's kid?",
    options: ["Andrew", "Noah", "Kabir", "Sam"],
    answer: "Noah",
  },
  {
    id: 208,
    question:
      "Which activity does Taylor enjoy most when visiting a friend's house?",
    options: [
      "Watching movies",
      "Playing board games",
      "Cooking together",
      "Going for a walk",
    ],
    answer: "Playing board games",
  },
  {
    id: 209,
    question:
      "Which store does Morgan frequently visit at the mall for cosmetics and beauty products?",
    options: ["Sephora", "Ulta", "Bath & Body Works", "MAC Cosmetics"],
    answer: "Sephora",
  },
  {
    id: 210,
    question: "What begins with T ends with T and has T in it?",
    options: ["Tent", "Toast", "Teapot", "Trot"],
    answer: "Teapot",
  },
  {
    id: 211,
    question: "What kind of items does Alex mostly shop for at a Fadam's shop?",
    options: ["Fresh produce", "Artisan crafts", "Clothing", "Electronics"],
    answer: "Fresh produce",
  },
  {
    id: 212,
    question:
      "What color is Emily's favorite hanger for organizing clothes in her wardrobe?",
    options: ["White", "Black", "Pink", "Wood finish"],
    answer: "Pink",
  },
  {
    id: 213,
    question: "What type of entertainment does Alex enjoy most at the mall?",
    options: ["Movie theater", "Arcade", "Ice skating rink", "Bowling alley"],
    answer: "Movie theater",
  },
  {
    id: 214,
    question: "Where does Tom keep his favorite pillow in the bedroom?",
    options: ["Under the bed", "On the bed", "On the chair", "On the floor"],
    answer: "On the floor",
  },
  {
    id: 215,
    question: "What has thirteen hearts, but no other organs?",
    options: ["Jellyfish", "Deck of cards", "Octopus", "Calendar"],
    answer: "Deck of cards",
  },
  {
    id: 216,
    question: "What is special about the year 1980?",
    options: ["Leap year", "Common year", "Calendar year", "Historic year"],
    answer: "Leap year",
  },
  {
    id: 217,
    question: "What is Taylor's preferred method of shopping for books?",
    options: ["Online", "Bookstore", "Library sale", "Secondhand store"],
    answer: "Online",
  },
  {
    id: 218,
    question:
      "Where does Jordan usually go in the mall to find home furnishings and decor?",
    options: [
      "Pottery Barn",
      "Crate & Barrel",
      "West Elm",
      "Bed Bath & Beyond",
    ],
    answer: "West Elm",
  },
  {
    id: 219,
    question:
      "What issue did Taylor experience with their laptop that required professional repair?",
    options: [
      "Cracked screen",
      "Hard drive failure",
      "Battery not charging",
      "Broken keyboard",
    ],
    answer: "Cracked screen",
  },
  {
    id: 220,
    question: "What is easier to get into than out of?",
    options: ["Trouble", "Bed", "House", "Car"],
    answer: "Trouble",
  },
  {
    id: 221,
    question: "When was Evergreen Academy established?",
    options: ["1956", "1957", "1977", "1980"],
    answer: "1977",
  },
  {
    id: 222,
    question:
      "How does Alex typically travel when going to visit a friend who lives in another city?",
    options: ["By car", "By train", "By plane", "By bus"],
    answer: "By plane",
  },
  {
    id: 223,
    question:
      "What type of meal does Morgan usually prepare for a friend when hosting them?",
    options: ["Brunch", "Dinner", "Dessert", "Appetizers"],
    answer: "Dinner",
  },
  {
    id: 224,
    question: "Which product does Emma swear by for her skincare routine?",
    options: [
      "Rosewater toner",
      "Vitamin C serum",
      "Hyaluronic acid moisturizer",
      "Tea tree oil cleanser",
    ],
    answer: "Hyaluronic acid moisturizer",
  },
  {
    id: 225,
    question: "What can fill a room but doesn't take up space?",
    options: ["Water", "Air", "Light", "Sound"],
    answer: "Light",
  },
  {
    id: 226,
    question:
      "What is the name of Emily's favorite café where she likes to get her morning coffee?",
    options: [
      "Brewed Bliss",
      "Java Junction",
      "Bean & Brew",
      "Espresso Emporium",
    ],
    answer: "Bean & Brew",
  },
  {
    id: 227,
    question:
      "What is the name of Tom's favorite local restaurant where he enjoys dining with friends?",
    options: [
      "The Bistro Lounge",
      "Savory Delights",
      "The Rustic Tavern",
      "The Cozy Corner Cafe",
    ],
    answer: "The Cozy Corner Cafe",
  },
  {
    id: 228,
    question: "Which fruit does Emma like to have for breakfast?",
    options: ["Apple", "Banana", "Orange", "Strawberry"],
    answer: "Banana",
  },
  {
    id: 229,
    question: "Which medicine does Sarah always keep in her first aid kit?",
    options: ["Ibuprofen", "Antihistamine", "Band-Aids", "Cough syrup"],
    answer: "Band-Aids",
  },
  {
    id: 230,
    question: "What can kids make but never see?",
    options: ["Noise", "Shadows", "Dreams", "Friends"],
    answer: "Noise",
  },
  {
    id: 231,
    question:
      "What upcoming event is Student Emma looking forward to attending on campus?",
    options: [
      "Cultural festival",
      "Career fair",
      "Sports tournament",
      "Academic conference",
    ],
    answer: "Career fair",
  },
  {
    id: 232,
    question: "How does Mark prefer to stay active during weekdays?",
    options: ["Running", "Yoga", "Going to the gym", "Playing basketball"],
    answer: "Going to the gym",
  },
  {
    id: 233,
    question:
      "What is the title of the recent bestselling novel that Emily recommended to her friends?",
    options: [
      "Whispers in the Wind",
      "Echoes of Eternity",
      "Secrets of the Moonlight",
      "Shadows of Serenity",
    ],
    answer: "Echoes of Eternity",
  },
  {
    id: 234,
    question: "Where does James work as a software developer?",
    options: [
      "Tech Innovations Inc.",
      "Digital Solutions Ltd.",
      "CodeCrafters",
      "ByteTech Systems",
    ],
    answer: "Tech Innovations Inc.",
  },
  {
    id: 235,
    question:
      "What comes out at night without being called, and is lost in the day without being stolen?",
    options: ["Stars", "Sleep", "Fireflies", "Shadow"],
    answer: "Stars",
  },
  {
    id: 236,
    question:
      "What is the title of the mystery novel that Emma recently enjoyed reading?",
    options: [
      "Shadows of Obscurity",
      "Secrets in the Shadows",
      "Whispering Shadows",
      "Echoes of Shadows",
    ],
    answer: "Whispering Shadows",
  },
  {
    id: 237,
    question: "What is the name of Jack's financial advisor?",
    options: ["Mr. Anderson", "Ms. Taylor", "Mr. Patel", "Ms. Garcia"],
    answer: "Mr. Patel",
  },
  {
    id: 238,
    question: "Who is Peter's trusted mechanic for servicing his car?",
    options: [
      "Auto Care Center",
      "Reliable Motors",
      "Speedy Service Garage",
      "Gearhead Garage",
    ],
    answer: "Reliable Motors",
  },
  {
    id: 239,
    question: "When does Student Olivia have her first class of the day?",
    options: ["9:00 AM", "10:00 AM", "11:00 AM", "12:00 PM"],
    answer: "10:00 AM",
  },
  {
    id: 240,
    question:
      "What ecosystem does Ecologist Jack study to understand wild animal behavior?",
    options: ["Rainforest", "Savanna", "Arctic tundra", "Coral reef"],
    answer: "Savanna",
  },
  {
    id: 241,
    question: "What is the name of Peter's mischievous pet parrot?",
    options: ["Mango", "Coco", "Sunny", "Peppy"],
    answer: "Coco",
  },
  {
    id: 242,
    question: "What is Lily's preferred genre of books to read before bedtime?",
    options: ["Mystery", "Romance", "Science fiction"],
    answer: "Mystery",
  },
  {
    id: 243,
    question: "What is the name of the book club that Sarah recently joined?",
    options: [
      "Literary Legends",
      "Bookworms Society",
      "Novel Ideas Club",
      "Reading Circle",
    ],
    answer: "Novel Ideas Club",
  },
  {
    id: 244,
    question:
      "What extracurricular activity does Student Mia participate in after college hours?",
    options: ["Sports", "Music", "Drama", "Debate club"],
    answer: "Drama",
  },
  {
    id: 245,
    question: "What do you call a dog magician?",
    options: [
      "Labra-cadabra-dor",
      "Magic mutt",
      "Spellhound",
      "Trickster terrier",
    ],
    answer: "Labra-cadabra-dor",
  },
  {
    id: 246,
    question: "What is Emma's preferred way to keep track of her daily tasks?",
    options: [
      "Digital planner app",
      "Bullet journal",
      "Sticky notes",
      "Desktop calendar",
    ],
    answer: "Digital planner app",
  },
  {
    id: 247,
    question: "What semester course does Student Jack find most challenging?",
    options: ["Mathematics", "Literature", "Biology", "Economics"],
    answer: "Mathematics",
  },
  {
    id: 248,
    question: "Where did Michael recently travel for a relaxing vacation?",
    options: ["Bali, Indonesia", "Maldives", "Switzerland", "Greece"],
    answer: "Maldives",
  },
  {
    id: 249,
    question:
      "What unique adaptation does Wildlife Educator Emma teach about in her presentations?",
    options: ["Camouflage", "Migration", "Hibernation", "Echolocation"],
    answer: "Camouflage",
  },
  {
    id: 250,
    question: "What do you get when you cross a zebra with a donkey?",
    options: ["Zorse", "Zonkey", "Zedonk", "Zebra-donkey"],
    answer: "Zonkey",
  },
  {
    id: 251,
    question: "What health supplement does Tom take regularly?",
    options: ["Omega-3 fish oil", "Vitamin C", "Probiotics", "Calcium"],
    answer: "Omega-3 fish oil",
  },
  {
    id: 252,
    question: "When does Olivia usually charge her laptop during the day?",
    options: [
      "Overnight",
      "During lunch break",
      "In the morning",
      "In the evening",
    ],
    answer: "Overnight",
  },
  {
    id: 253,
    question: "Which device does Emma find has the fastest charging port?",
    options: ["Phone", "Laptop", "Tablet", "Smartwatch"],
    answer: "Tablet",
  },
  {
    id: 254,
    question: "How does Jack conserve his laptop battery during long meetings?",
    options: [
      "Lowering screen brightness",
      "Closing unnecessary applications",
      "Using battery saver mode",
      "Plugging into a power source",
    ],
    answer: "Closing unnecessary applications",
  },
  {
    id: 255,
    question:
      "Give me a drink, and I will die. Feed me, and I'll get bigger. What am I?",
    options: ["Fire", "Balloon", "Plant", "Bread"],
    answer: "Fire",
  },
  {
    id: 256,
    question: "What is Sophie's favorite type of exercise?",
    options: ["Running", "Pilates", "Zumba", "Weightlifting"],
    answer: "Zumba",
  },
  {
    id: 257,
    question:
      "What repair did Alex have done on their smartwatch after it stopped working?",
    options: [
      "Battery replacement",
      "Screen repair",
      "Charging port fix",
      "Software update",
    ],
    answer: "Battery replacement",
  },
  {
    id: 258,
    question:
      "What specific problem did Jordan's tablet have that required a screen replacement?",
    options: [
      "Cracked screen",
      "Unresponsive touch",
      "Fading display",
      "Broken back cover",
    ],
    answer: "Cracked screen",
  },
  {
    id: 259,
    question: "What is Tim's favorite weekend activity?",
    options: [
      "Playing soccer",
      "Reading books",
      "Watching movies",
      "Gardening",
    ],
    answer: "Watching movies",
  },
  {
    id: 260,
    question: "If you drop a yellow hat in the Red Sea, what does it become?",
    options: ["Wet", "Orange", "A sea hat", "Lost"],
    answer: "Wet",
  },
  {
    id: 261,
    question: "Where does Sarah buy her favorite herbal tea blend?",
    options: [
      "Serenity Teahouse",
      "Tranquil Brews",
      "Zen Tea Emporium",
      "Harmony Teas",
    ],
    answer: "Serenity Teahouse",
  },
  {
    id: 262,
    question: "How does Student Sarah prefer to pay her college fees?",
    options: [
      "Monthly installments",
      "Lump sum at the beginning of the semester",
      "Using a student loan",
      "Scholarships and grants",
    ],
    answer: "Monthly installments",
  },
  {
    id: 263,
    question: "Which neighborhood does the college bus route pass through?",
    options: ["Downtown", "Suburbia", "Industrial area", "Residential area"],
    answer: "Suburbia",
  },
  {
    id: 264,
    question: "What is Sarah's preferred way to relax after a long day?",
    options: [
      "Listening to music",
      "Taking a bath",
      "Going for a walk",
      "Meditating",
    ],
    answer: "Taking a bath",
  },
  {
    id: 265,
    question:
      "There is one word spelled wrong in every English dictionary. What is it?",
    options: ["Mistake", "Wrong", "Incorrect", "Misspelled"],
    answer: "Wrong",
  },
  {
    id: 266,
    question:
      "Which librarian does Student Emma consult for assistance with her research paper?",
    options: ["Mr. Johnson", "Ms. Smith", "Mr. Brown", "Ms. Taylor"],
    answer: "Ms. Smith",
  },
  {
    id: 267,
    question:
      "Which subject does Student Sarah feel most prepared for before the semester exams?",
    options: ["Physics", "History", "Psychology", "Computer Science"],
    answer: "Psychology",
  },
  {
    id: 268,
    question: "What is the name of Sarah's favorite salon that she visits?",
    options: [
      "Hair Envy",
      "Chic Cuts",
      "Glamour Hair Studio",
      "Trendy Tresses",
    ],
    answer: "Glamour Hair Studio",
  },
  {
    id: 269,
    question:
      "What club event is Student Michael organizing for the student body next month?",
    options: [
      "Movie night",
      "Charity fundraiser",
      "Quiz competition",
      "Talent show",
    ],
    answer: "Charity fundraiser",
  },
  {
    id: 270,
    question: "What comes down but never goes up?",
    options: ["Temperature", "Rain", "Age", "Light"],
    answer: "Age",
  },
  {
    id: 271,
    question:
      "What study technique does Professor Jack recommend to his students for effective learning?",
    options: [
      "Mind mapping",
      "Flashcards",
      "Group study sessions",
      "Mock exams",
    ],
    answer: "Mind mapping",
  },
  {
    id: 272,
    question:
      "Which type of cuisine does Michael enjoy experimenting with in the kitchen?",
    options: ["Italian", "Mexican", "Chinese", "Indian"],
    answer: "Italian",
  },
  {
    id: 273,
    question:
      "How does Student Liam plan to manage his college expenses apart from tuition fees?",
    options: ["Part-time job", "Savings", "Financial aid", "Parental support"],
    answer: "Part-time job",
  },
  {
    id: 274,
    question: "What material is Emma's favorite study table made of?",
    options: ["Wood", "Glass", "Metal", "Plastic"],
    answer: "Wood",
  },
  {
    id: 275,
    question: "What invention lets you look right through a wall?",
    options: ["Window", "Mirror", "Glasses", "Telescope"],
    answer: "Window",
  },
  {
    id: 276,
    question: "What type of operation did Emma undergo last year?",
    options: [
      "Appendectomy",
      "Knee surgery",
      "Gallbladder removal",
      "Heart surgery",
    ],
    answer: "Gallbladder removal",
  },
  {
    id: 277,
    question: "What type of cleanser does Emma use for her skincare routine?",
    options: [
      "Foaming cleanser",
      "Cream cleanser",
      "Gel cleanser",
      "Micellar water",
    ],
    answer: "Gel cleanser",
  },
  {
    id: 278,
    question:
      "Who is Jack's trusted family doctor for routine health check-ups?",
    options: ["Dr. Johnson", "Dr. Patel", "Dr. Thompson", "Dr. Davis"],
    answer: "Dr. Johnson",
  },
  {
    id: 279,
    question:
      "What is Tom's preferred form of exercise for improving cardiovascular health?",
    options: ["Running", "Cycling", "Swimming", "Jump rope"],
    answer: "Cycling",
  },
  {
    id: 280,
    question: "What is always on its way but never arrives?",
    options: ["Sunrise", "Package", "Train", "Tomorrow"],
    answer: "Tomorrow",
  },
  {
    id: 281,
    question:
      "Which injury did Jack sustained while playing soccer last season?",
    options: ["Sprained knee", "Broken finger", "Concussion", "Twisted ankle"],
    answer: "Twisted ankle",
  },
  {
    id: 282,
    question: "What type of nail polish does Sarah use to prevent chipping?",
    options: ["Base coat", "Top coat", "Quick-dry", "Strengthener"],
    answer: "Top coat",
  },
  {
    id: 283,
    question: "Where does Michael usually buy his favorite brand of soap?",
    options: ["FreshMart", "Clean & Clear", "Purely Clean", "Soap Supreme"],
    answer: "Soap Supreme",
  },
  {
    id: 284,
    question: "What subject does Ms. Evelyn Hawthorne teach?",
    options: ["Mathematics", "History", "Science", "English"],
    answer: "English",
  },
  {
    id: 285,
    question: "What can you put in a bucket to make it weigh less?",
    options: ["Water", "Hole", "Sand", "Air"],
    answer: "Hole",
  },
  {
    id: 286,
    question: "Who is Kabir's teacher?",
    options: [
      "Ms. Evelyn Hawthorne",
      "Mr. Benjamin Carter",
      "Ms. Samantha Reyes",
      "Ms. Thomasina Greene",
    ],
    answer: "Ms. Evelyn Hawthorne",
  },
  {
    id: 287,
    question:
      "What injury did Sarah sustained while playing sports last summer?",
    options: [
      "Sprained ankle",
      "Knee ligament tear",
      "Shoulder dislocation",
      "Wrist fracture",
    ],
    answer: "Sprained ankle",
  },
  {
    id: 288,
    question: "How many subjects does Kabir have?",
    options: ["6", "5", "4", "7"],
    answer: "5",
  },
  {
    id: 289,
    question: "Where did Jack go for his last hospital check-up?",
    options: [
      "Mercy Hospital",
      "Healing Hands Clinic",
      "CareWell Medical Center",
      "Wellness Hospital",
    ],
    answer: "CareWell Medical Center",
  },
  {
    id: 290,
    question: "What is taken before you can get it?",
    options: ["Photograph", "Ticket", "Exam", "Offer"],
    answer: "Photograph",
  },
  {
    id: 291,
    question:
      "What is Emma's preferred method to manage stress and maintain mental health?",
    options: ["Meditation", "Deep breathing exercises", "Journaling", "Yoga"],
    answer: "Meditation",
  },
  {
    id: 292,
    question: "Which type of clock does Jack prefer to use in his office?",
    options: ["Digital clock", "Analog clock", "Wall clock", "Smart clock"],
    answer: "Analog clock",
  },
  {
    id: 293,
    question: "Which hobby does Jamie prefer for socializing with friends?",
    options: ["Board games", "Bowling", "Karaoke", "Book club"],
    answer: "Karaoke",
  },
  {
    id: 294,
    question: "What pain relief method does Sarah prefer for headaches?",
    options: [
      "Acupuncture",
      "Painkillers",
      "Aromatherapy",
      "Hot/cold compress",
    ],
    answer: "Painkillers",
  },
  {
    id: 295,
    question:
      "Imagine you are in a room with no windows or doors. How will you get out?",
    options: [
      "Break through the wall",
      "Call for help",
      "Stop imagining",
      "Find a hidden exit",
    ],
    answer: "Stop imagining",
  },
  {
    id: 296,
    question:
      "Which brand of shampoo does Tom trust for his daily hair care routine?",
    options: [
      "Silk & Shine",
      "Fresh Clean",
      "Herbal Essence",
      "Moisture Boost",
    ],
    answer: "Herbal Essence",
  },
  {
    id: 297,
    question: "What is Jamie's favorite nail polish color for everyday wear?",
    options: ["Blue", "Red", "Pink", "French manicure"],
    answer: "Pink",
  },
  {
    id: 298,
    question: "How does Morgan typically cope with feelings of anxiety?",
    options: [
      "Practicing mindfulness",
      "Watching movies",
      "Avoiding stressful situations",
      "Seeking professional help",
    ],
    answer: "Practicing mindfulness",
  },
  {
    id: 299,
    question: "Which vegetable does Morgan often find on sale at the market?",
    options: ["Tomatoes", "Spinach", "Potatoes", "Onions"],
    answer: "Potatoes",
  },
  {
    id: 300,
    question:
      "What's black when you get it, red when you use it, and white when you're all through with it?",
    options: ["A newspaper", "Charcoal", "A pencil", "A piece of bread"],
    answer: "Charcoal",
  },
  {
    id: 301,
    question:
      "Which gadget did Taylor have trouble with after an update, requiring a system restore?",
    options: ["Laptop", "Smartwatch", "Tablet", "Smart TV"],
    answer: "Laptop",
  },
  {
    id: 302,
    question: "Which type of dance is Jordan considering as a new hobby?",
    options: ["Zumba", "Tap dance", "Belly dance", "Breakdancing"],
    answer: "Belly dance",
  },
  {
    id: 303,
    question:
      "What is Taylor's recommended interval for getting a professional dental cleaning?",
    options: [
      "Every 6 months",
      "Every 12 months",
      "Every 3 months",
      "Every 18 months",
    ],
    answer: "Every 6 months",
  },
  {
    id: 304,
    question: "Which hobby does Taylor enjoy most on weekends?",
    options: [
      "Hiking",
      "Playing video games",
      "Playing a musical instrument",
      "Knitting",
    ],
    answer: "Hiking",
  },
  {
    id: 305,
    question: "What do you call a bear with no teeth?",
    options: ["A gummy bear", "A fluffy bear", "A teddy bear", "A sleepy bear"],
    answer: "A gummy bear",
  },
  {
    id: 306,
    question: "What is Jordan's approach to reducing exam stress?",
    options: [
      "Regular exercise",
      "Meditation",
      "Studying in advance",
      "Taking practice exams",
    ],
    answer: "Meditation",
  },
  {
    id: 307,
    question:
      "What is Taylor's preferred method of selling surplus vegetables from their garden?",
    options: [
      "Farmers' market",
      "Online marketplace",
      "Local grocery store",
      "Neighborhood stand",
    ],
    answer: "Farmers' market",
  },
  {
    id: 308,
    question: "Which method does Taylor find most helpful for reducing stress?",
    options: [
      "Meditation",
      "Listening to music",
      "Taking a walk",
      "Engaging in a hobby",
    ],
    answer: "Engaging in a hobby",
  },
  {
    id: 309,
    question: "What type of exam format does Jamie prefer?",
    options: ["Multiple-choice", "Essay", "True/False", "Short answer"],
    answer: "Multiple-choice",
  },
  {
    id: 310,
    question: "What do you get when you cross a snowman and a vampire?",
    options: [
      "Frostbite",
      "Ice cream",
      "A chilly thrill",
      "A cold-blooded snowman",
    ],
    answer: "Frostbite",
  },
  {
    id: 311,
    question:
      "What problem did Jamie encountered with their smartphone that led them to seek repair?",
    options: [
      "Water damage",
      "Overheating",
      "Connectivity issues",
      "Battery swelling",
    ],
    answer: "Water damage",
  },
  {
    id: 312,
    question:
      "How does Jordan typically negotiate prices when buying vegetables at the market?",
    options: [
      "Asking for bulk discounts",
      "Comparing prices with nearby stalls",
      "Buying in larger quantities",
      "Using a loyalty card",
    ],
    answer: "Asking for bulk discounts",
  },
  {
    id: 313,
    question:
      "What type of vegetable does Jamie frequently buy at the market for their salads?",
    options: ["Lettuce", "Carrots", "Bell peppers", "Cucumbers"],
    answer: "Cucumbers",
  },
  {
    id: 314,
    question: "What is Alex's preferred way to address emotional overwhelm?",
    options: [
      "Talking to a therapist",
      "Spending time with loved ones",
      "Exercising",
      "Reading self-help books",
    ],
    answer: "Spending time with loved ones",
  },
  {
    id: 315,
    question: "Why don't skeletons fight each other?",
    options: [
      "They don't like the sound of clattering",
      "They're too bony",
      "They're always falling apart",
      "They don't have the guts",
    ],
    answer: "They don't have the guts",
  },
  {
    id: 316,
    question: "What is Alex's common method for preventing bad breath?",
    options: [
      "Using mouthwash",
      "Chewing gum",
      "Brushing twice a day",
      "Drinking water",
    ],
    answer: "Using mouthwash",
  },
  {
    id: 317,
    question:
      "Which dental procedure did Morgan have done to address a cavity?",
    options: ["Filling", "Root canal", "Crown", "Extraction"],
    answer: "Filling",
  },
  {
    id: 318,
    question: "Which hobby does Alex find most rewarding?",
    options: ["Volunteering", "Collecting stamps", "Baking", "Traveling"],
    answer: "Volunteering",
  },
  {
    id: 319,
    question: "What type of hobby is Jordan most interested in?",
    options: ["Crafting", "Surfing", "Astronomy", "Martial arts"],
    answer: "Astronomy",
  },
  {
    id: 320,
    question: "What did the big flower say to the little flower?",
    options: [
      "Hey, bud!",
      "You're blooming marvelous!",
      "Petal to the metal!",
      "Grow up!",
    ],
    answer: "Hey, bud!",
  },
  {
    id: 321,
    question:
      "Which dance accessory does Taylor find essential for practicing ballet?",
    options: ["Pointe shoes", "Dance belt", "Tap shoes", "Ballet slippers"],
    answer: "Pointe shoes",
  },
  {
    id: 322,
    question: "What is Taylor's go-to ice cream flavor for a milkshake?",
    options: [
      "Cookies and cream",
      "Coffee",
      "Peanut butter cup",
      "Caramel swirl",
    ],
    answer: "Cookies and cream",
  },
  {
    id: 323,
    question:
      "Which ice cream flavor does Morgan find most refreshing in summer?",
    options: ["Lemon sorbet", "Mango", "Coconut", "Berry blast"],
    answer: "Mango",
  },
  {
    id: 324,
    question: "What is Morgan's favorite dance-related event?",
    options: [
      "Dance recitals",
      "Dance festivals",
      "Dance battles",
      "Dance workshops",
    ],
    answer: "Dance recitals",
  },
  {
    id: 325,
    question: "What does a ghost use to wash its hair?",
    options: ["Ghost soap", "Shamp-boo", "Haunting gel", "Spectral rinse"],
    answer: "Shamp-boo",
  },
  {
    id: 326,
    question: "Which style of spectacles does Tom wear for reading?",
    options: ["Rimless", "Aviator", "Wayfarer", "Round"],
    answer: "Rimless",
  },
  {
    id: 327,
    question:
      "What unique ice cream flavor does Alex enjoy trying at specialty shops?",
    options: ["Matcha green tea", "Lavender honey", "Bacon maple", "Wasabi"],
    answer: "Lavender honey",
  },
  {
    id: 328,
    question: "What type of cuisine is Jamie's favorite for a holiday feast?",
    options: ["Italian", "Mexican", "Traditional American", "Indian"],
    answer: "Traditional American",
  },
  {
    id: 329,
    question:
      "What dish does Taylor typically prepare for a large family gathering?",
    options: ["Roast turkey", "Lasagna", "BBQ ribs", "Vegetarian chili"],
    answer: "Roast turkey",
  },
  {
    id: 330,
    question:
      "What five-letter word becomes shorter when you add two letters to it?",
    options: ["Space", "Light", "Short", "Crisp"],
    answer: "Short",
  },
  {
    id: 331,
    question:
      "What type of notebook does Sarah use for jotting down ideas and notes?",
    options: ["Spiral-bound", "Leather-bound", "Hardcover", "Eco-friendly"],
    answer: "Leather-bound",
  },
  {
    id: 332,
    question: "Which cuisine does Mia enjoy the most?",
    options: ["Italian", "Chinese", "Mexican", "Indian"],
    answer: "Mexican",
  },
  {
    id: 333,
    question:
      "What is Emma's favorite way to stay active during the winter months?",
    options: ["Skiing", "Ice skating", "Snowboarding", "Indoor yoga"],
    answer: "Indoor yoga",
  },
  {
    id: 334,
    question:
      "Which social media platform does Jack use most frequently to connect with friends?",
    options: ["SnapSocial", "ChatSpace", "ConnectHub", "FriendNet"],
    answer: "ConnectHub",
  },
  {
    id: 335,
    question: "What kind of ball doesn't bounce?",
    options: ["Football", "Basketball", "Beach ball", "Snowball"],
    answer: "Snowball",
  },
  {
    id: 336,
    question: "Which vacation destination does Jake dream of visiting?",
    options: ["Paris", "Bali", "New York City", "Tokyo"],
    answer: "Bali",
  },
  {
    id: 337,
    question: "Where did Jack go for his last hiking adventure?",
    options: [
      "Rocky Mountain Park",
      "Appalachian Trail",
      "Yosemite National Park",
      "Grand Canyon",
    ],
    answer: "Yosemite National Park",
  },
  {
    id: 338,
    question: "What is Emily's preferred ringtone on her smartphone?",
    options: [
      "Classic chime",
      "Pop song snippet",
      "Nature sounds",
      "Custom melody",
    ],
    answer: "Custom melody",
  },
  {
    id: 339,
    question: "Which material does Sarah prefer for her bedsheets?",
    options: ["Cotton", "Silk", "Flannel", "Microfiber"],
    answer: "Cotton",
  },
  {
    id: 340,
    question:
      "I protect, I stand tall. My goal is to strike fear in all. What am I?",
    options: ["A knight", "A scarecrow", "A soldier", "A superhero"],
    answer: "A scarecrow",
  },
  {
    id: 341,
    question: "Which season does Alex look forward to the most?",
    options: ["Spring", "Summer", "Autumn", "Winter"],
    answer: "Summer",
  },
  {
    id: 342,
    question: "Which phone feature does Michael use to set daily reminders?",
    options: ["Calendar app", "Reminder widget", "Alarm clock", "Notes app"],
    answer: "Reminder widget",
  },
  {
    id: 343,
    question: "Which brand of pen does Jack always carry in his briefcase?",
    options: ["InkMaster", "Precision Write", "SmoothFlow", "PenPerfection"],
    answer: "SmoothFlow",
  },
  {
    id: 344,
    question: "What type of coffee does Tom enjoy in the morning?",
    options: ["Espresso", "Latte", "Americano", "Cappuccino"],
    answer: "Latte",
  },
  {
    id: 345,
    question:
      "If you're running in a race and you pass the person in second place, what place are you in?",
    options: ["First place", "Third place", "Second place", "Fourth place"],
    answer: "Second place",
  },
  {
    id: 346,
    question:
      "What color towel does Emily prefer to use after a relaxing bath?",
    options: ["White", "Blue", "Pink", "Green"],
    answer: "Blue",
  },
  {
    id: 347,
    question: "What is Sam's favorite color for a car?",
    options: ["Red", "Blue", "Black", "Silver"],
    answer: "Blue",
  },
  {
    id: 348,
    question: "What color is Emma's favorite handbag?",
    options: ["Black", "Brown", "Red", "Blue"],
    answer: "Red",
  },
  {
    id: 349,
    question:
      "What time does Sarah usually set her morning alarm on her phone?",
    options: ["6:00 AM", "7:00 AM", "8:00 AM", "9:00 AM"],
    answer: "7:00 AM",
  },
  {
    id: 350,
    question: "What is white, but smells like blue paint?",
    options: [
      "A white rose",
      "A whiteboard marker",
      "White paint",
      "A snowball",
    ],
    answer: "White paint",
  },
  {
    id: 351,
    question: "What sport is Sarah passionate about and practices regularly?",
    options: ["Tennis", "Swimming", "Soccer", "Golf"],
    answer: "Tennis",
  },
  {
    id: 352,
    question:
      "Which tool does David use to remind colleagues about an upcoming deadline?",
    options: [
      "Messaging app",
      "Conference call",
      "Shared schedule",
      "Email thread",
    ],
    answer: "Shared schedule",
  },
  {
    id: 353,
    question: "What extracurricular activity does Kate enjoy the most?",
    options: ["Soccer", "Chess", "Painting", "Music"],
    answer: "Music",
  },
  {
    id: 354,
    question: "Which subject is Kabir's favorite?",
    options: ["Mathematics", "History", "Science", "English"],
    answer: "Mathematics",
  },
  {
    id: 355,
    question: "I jump when I walk, and sit when I stand. What am I?",
    options: ["A frog", "A rabbit", "A kangaroo", "A grasshopper"],
    answer: "A kangaroo",
  },
  {
    id: 356,
    question:
      "What type of hotel does Emily prefer when traveling for business?",
    options: [
      "Luxury hotel",
      "Boutique hotel",
      "Chain hotel",
      "Extended stay hotel",
    ],
    answer: "Extended stay hotel",
  },
  {
    id: 357,
    question:
      "What treatment does Chloe choose for a relaxing experience at the parlour?",
    options: ["Massage", "Body scrub", "Aromatherapy", "Pedicure"],
    answer: "Massage",
  },
  {
    id: 358,
    question: "How does Emily prefer to schedule her appointments?",
    options: ["Messaging app", "Phone call", "Video conference", "Email"],
    answer: "Phone call",
  },
  {
    id: 359,
    question:
      "Which hotel feature is most important to Jessica when booking a vacation stay?",
    options: ["Pool", "Spa", "Complimentary breakfast", "Gym"],
    answer: "Spa",
  },
  {
    id: 360,
    question: "The alphabet goes from A to Z but I go Z to A. What am I?",
    options: ["Boomerang", "Reverse engineer", "Zebra", "Librarian"],
    answer: "Zebra",
  },
  {
    id: 361,
    question: "What does Alex prepare before a crucial meeting?",
    options: [
      "Laptop presentation",
      "Project plan",
      "Maintenance schedule",
      "Safety checklist",
    ],
    answer: "Laptop presentation",
  },
  {
    id: 362,
    question:
      "Which communication method does Michael use to confirm a conference call?",
    options: ["Text message", "Voicemail", "Instant messaging", "Video call"],
    answer: "Instant messaging",
  },
  {
    id: 363,
    question: "Which task is Sam assigned to complete by the end of the day?",
    options: [
      "Writing a report",
      "Repairing laptops",
      "Painting office walls",
      "Checking plumbing leaks",
    ],
    answer: "Repairing laptops",
  },
  {
    id: 364,
    question: "What is the relationship between John and Emily?",
    options: [
      "Brother and sister",
      "Father and daughter",
      "Uncle and niece",
      "Cousins",
    ],
    answer: "Cousins",
  },
  {
    id: 365,
    question: "What goes up and down but doesn't move?",
    options: ["Staircase", "Seesaw", "Temperature", "Elevator"],
    answer: "Staircase",
  },
  {
    id: 366,
    question: "Which office equipment does Sarah need for her daily tasks?",
    options: [
      "Laptop",
      "Painting supplies",
      "Plumbing tools",
      "Electrical wiring kit",
    ],
    answer: "Laptop",
  },
  {
    id: 367,
    question: "How are Sarah and Alex related to each other?",
    options: [
      "Mother and son",
      "Grandmother and grandson",
      "Sister and brother",
      "Aunt and nephew",
    ],
    answer: "Sister and brother",
  },
  {
    id: 368,
    question: "What kind of pet does Emma want to adopt?",
    options: ["Dog", "Cat", "Rabbit", "Bird"],
    answer: "Cat",
  },
  {
    id: 369,
    question: "Which musical instrument does Liam want to learn to play?",
    options: ["Piano", "Guitar", "Violin", "Drums"],
    answer: "Guitar",
  },
  {
    id: 370,
    question: "John's father has three sons: Huey, Louie, and _____?",
    options: ["Dewey", "Billy", "John", "Max"],
    answer: "John",
  },
  {
    id: 371,
    question: "Who is the niece of Lisa?",
    options: ["Olivia", "Sarah", "Kate", "Emma"],
    answer: "Emma",
  },
  {
    id: 372,
    question: "What snack does Michael prefer to carry for long flights?",
    options: ["Granola bars", "Sandwiches", "Fruit", "Trail mix"],
    answer: "Granola bars",
  },
  {
    id: 373,
    question: "Who is responsible for coordinating the team-building activity?",
    options: ["Emily", "Alex", "Sarah", "Michael"],
    answer: "Emily",
  },
  {
    id: 374,
    question: "Which TV series genre does Mia binge-watch?",
    options: ["Comedy", "Drama", "Sci-Fi", "Crime thriller"],
    answer: "Drama",
  },
  {
    id: 375,
    question: "During which month do people sleep the least?",
    options: ["January", "June", "September", "February"],
    answer: "February",
  },
  {
    id: 376,
    question: "What is John's favorite dish to prepare for family dinners?",
    options: ["Spaghetti", "BBQ ribs", "Chicken Alfredo", "Tacos"],
    answer: "Chicken Alfredo",
  },
  {
    id: 377,
    question: "From which city does Jack begin his journey?",
    options: ["New York", "London", "Sydney", "Tokyo"],
    answer: "New York",
  },
  {
    id: 378,
    question: "What task does James prioritize first in the office?",
    options: [
      "Writing a report",
      "Attending a meeting",
      "Fixing plumbing issues",
      "Checking laptop updates",
    ],
    answer: "Attending a meeting",
  },
  {
    id: 379,
    question: "Who is the aunt of Emily?",
    options: ["Sarah", "Lisa", "Martha", "Olivia"],
    answer: "Lisa",
  },
  {
    id: 380,
    question: "When things go wrong, what can you always count on?",
    options: ["Your friends", "Your family", "Your fingers", "Your luck"],
    answer: "Your fingers",
  },
  {
    id: 381,
    question: "Who is the grandson of Grandpa Jack?",
    options: ["David", "Michael", "Tom", "James"],
    answer: "Michael",
  },
  {
    id: 382,
    question:
      "What payment method does Sarah find most secure for large transactions?",
    options: ["Wire transfer", "Credit card", "Cryptocurrency", "Prepaid card"],
    answer: "Wire transfer",
  },
  {
    id: 383,
    question: "Which pet does Emma want to adopt for her birthday?",
    options: ["Puppy", "Kitten", "Rabbit", "Parrot"],
    answer: "Kitten",
  },
  {
    id: 384,
    question: "In which train compartment does James book his seat?",
    options: ["Coach A", "Coach B", "Coach C", "Coach D"],
    answer: "Coach C",
  },
  {
    id: 385,
    question:
      "I add five to nine and get two. The answer is correct, so what am I?",
    options: ["A math mistake", "A calendar", "A puzzle", "A clock"],
    answer: "A clock",
  },
  {
    id: 386,
    question: "What essential item does Emily always make sure to pack?",
    options: [
      "Portable charger",
      "Travel pillow",
      "Travel-sized toiletries",
      "Travel guidebook",
    ],
    answer: "Portable charger",
  },
  {
    id: 387,
    question: "Who is the granddaughter of Grandma Sarah?",
    options: ["Emily", "Olivia", "Lucy", "Mia"],
    answer: "Olivia",
  },
  {
    id: 388,
    question: "Who is the brother of Lucy?",
    options: ["Alex", "Michael", "Tom", "David"],
    answer: "David",
  },
  {
    id: 389,
    question:
      "Which railway station does Mia depart from for her weekend getaway?",
    options: [
      "Central Station",
      "Union Station",
      "Grand Central Terminal",
      "King's Cross Station",
    ],
    answer: "Union Station",
  },
  {
    id: 390,
    question:
      "What word is pronounced the same if you take away four of its five letters?",
    options: ["Chair", "Bread", "Queue", "Sheep"],
    answer: "Queue",
  },
  {
    id: 391,
    question: "Where does Sarah plan to travel for her next vacation?",
    options: ["Paris", "Bali", "New York City", "Tokyo"],
    answer: "Bali",
  },
  {
    id: 392,
    question:
      "What is Chloe's go-to method for keeping the kitchen countertops clean?",
    options: [
      "All-purpose cleaner",
      "Disinfecting wipes",
      "Soap and water",
      "Lemon juice and baking soda",
    ],
    answer: "All-purpose cleaner",
  },
  {
    id: 393,
    question: "What type of jewelry does Emily prefer for formal occasions?",
    options: [
      "Diamond earrings",
      "Gold bracelet",
      "Pearl necklace",
      "Silver ring",
    ],
    answer: "Pearl necklace",
  },
  {
    id: 394,
    question:
      "Which type of dessert does Morgan often serve at a festive meal?",
    options: ["Pumpkin pie", "Cheesecake", "Fruit tart", "Brownies"],
    answer: "Cheesecake",
  },
  {
    id: 395,
    question:
      "Which tracking method does Wildlife Researcher Emily use to monitor lion populations?",
    options: ["GPS collars", "Satellite tags", "Radio telemetry", "Microchips"],
    answer: "GPS collars",
  },
  {
    id: 396,
    question:
      "Which plant does Chloe most often use for creating a vertical garden?",
    options: ["Ivy", "English lavender", "Pothos", "Peperomia"],
    answer: "Ivy",
  },
  {
    id: 397,
    question: "Which hobby does Jordan pursue to stay fit and healthy?",
    options: ["Running", "Cycling", "Swimming", "Dance classes"],
    answer: "Dance classes",
  },
  {
    id: 398,
    question: "Which hobby does Morgan find relaxing and therapeutic?",
    options: ["Painting", "Fishing", "Puzzle-solving", "Gardening"],
    answer: "Gardening",
  },
  {
    id: 399,
    question: "Which bus route does Emma take to reach the city center?",
    options: ["Bus 101", "Bus 204", "Bus 309", "Bus 412"],
    answer: "Bus 204",
  },
  {
    id: 400,
    question: "What kind of cup doesn't hold water?",
    options: ["A teacup", "A cupcake", "A coffee cup", "A trophy cup"],
    answer: "A cupcake",
  },
  {
    id: 401,
    question:
      "Which ornament does Jessica like to use for decorating her living room?",
    options: ["Decorative vases", "Table lamps", "Picture frames", "Figurines"],
    answer: "Decorative vases",
  },
  {
    id: 402,
    question: "Who is the daughter of Martha?",
    options: ["Emily", "Anna", "Mia", "Kate"],
    answer: "Anna",
  },
  {
    id: 403,
    question: "What is Emily's preferred method for cleaning windows?",
    options: [
      "Glass cleaner and paper towels",
      "Vinegar and newspaper",
      "Squeegee",
      "Microfiber cloth",
    ],
    answer: "Squeegee",
  },
  {
    id: 404,
    question: "What is Laura's preferred method for finding hotel deals?",
    options: [
      "Booking websites",
      "Hotel loyalty programs",
      "Travel agencies",
      "Direct hotel websites",
    ],
    answer: "Booking websites",
  },
  {
    id: 405,
    question: "Who is the sister of Alex?",
    options: ["Emma", "Kate", "Lucy", "Mia"],
    answer: "Lucy",
  },
  {
    id: 406,
    question: "Which household chore does Jessica find most satisfying?",
    options: ["Vacuuming", "Dusting", "Washing dishes", "Organizing closets"],
    answer: "Organizing closets",
  },
  {
    id: 407,
    question: "Who is the uncle of Anna?",
    options: ["Mike", "John", "Jake", "Alex"],
    answer: "John",
  },
  {
    id: 408,
    question: "What dish does Sarah plan to prepare for the dinner party?",
    options: [
      "Spaghetti Bolognese",
      "Grilled Salmon",
      "Tacos",
      "Veggie Stir-Fry",
    ],
    answer: "Grilled Salmon",
  },
  {
    id: 409,
    question: "What flavor does Jamie prefer for a classic ice cream float?",
    options: ["Root beer", "Vanilla", "Chocolate", "Strawberry"],
    answer: "Root beer",
  },
  {
    id: 410,
    question:
      "Which dance style is Alex currently learning from online tutorials?",
    options: ["Hip-hop", "Salsa", "Jazz", "Irish dance"],
    answer: "Salsa",
  },
  {
    id: 411,
    question:
      "Which strategy does the team decide to implement for the new project?",
    options: [
      "Agile methodology",
      "Waterfall approach",
      "Scrum framework",
      "Lean startup principles",
    ],
    answer: "Agile methodology",
  },
  {
    id: 412,
    question:
      "What type of plant does Emily use to purify the air in her home?",
    options: ["Aloe vera", "Snake plant", "Spider plant", "Bamboo palm"],
    answer: "Snake plant",
  },
  {
    id: 413,
    question: "Which flavor does Jamie prefer for their ice cream sundae?",
    options: ["Chocolate", "Vanilla", "Strawberry", "Mint chocolate chip"],
    answer: "Mint chocolate chip",
  },
  {
    id: 414,
    question: "What type of dance performance does Jamie prefer to watch?",
    options: ["Ballet", "Street dance", "Folk dance", "Contemporary"],
    answer: "Contemporary",
  },
  {
    id: 415,
    question:
      "What payment method does Chloe use for her subscription services?",
    options: [
      "Automatic bank debit",
      "Credit card",
      "PayPal",
      "Digital wallet",
    ],
    answer: "Credit card",
  },
  {
    id: 416,
    question:
      "What cleaning product does Sarah use for scrubbing bathroom tiles?",
    options: [
      "Baking soda",
      "Abrasive cleaner",
      "Vinegar and water",
      "Bleach solution",
    ],
    answer: "Vinegar and water",
  },
  {
    id: 417,
    question:
      "Which dance form is Morgan interested in learning for social events?",
    options: ["Ballroom", "Swing", "Tango", "Latin"],
    answer: "Ballroom",
  },
  {
    id: 418,
    question:
      "What is Jordan's favorite ice cream flavor for baking into desserts?",
    options: [
      "Cookies and cream",
      "Strawberry shortcake",
      "Chocolate chip cookie dough",
      "Key lime pie",
    ],
    answer: "Chocolate chip cookie dough",
  },
  {
    id: 419,
    question: "Who is the cousin of James?",
    options: ["Jake", "Alex", "Michael", "David"],
    answer: "Jake",
  },
  {
    id: 420,
    question:
      "Which payment option does Jessica use most often for in-store purchases?",
    options: [
      "Cash",
      "Contactless payment",
      "Bank transfer",
      "Mobile payment app",
    ],
    answer: "Contactless payment",
  },
];
